// import { Skeleton, useMediaQuery, useTheme } from '@mui/material';
// import React, { useEffect, useState, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// // import PublishIcon from '@mui/icons-material/Publish';
// import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import { useLocation } from 'react-router-dom';
// import HistoryIcon from '@mui/icons-material/History';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
//   Box,
//   CircularProgress,
//   Chip,
//   Pagination,
//   Stack,
//   Card,
//   CardContent,
//   Avatar,
//   TextField,
//   MenuItem,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   IconButton,
//   Checkbox,
//   FormControlLabel,
//   Switch,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Divider,
//   Snackbar,
//   Alert,
//   Tooltip,
//   Grid,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import SearchIcon from '@mui/icons-material/Search';
// import SettingsIcon from '@mui/icons-material/Settings';
// import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import SevereColdIcon from '@mui/icons-material/SevereCold';
// import CheckIcon from '@mui/icons-material/Check';
// import EditNoteIcon from '@mui/icons-material/EditNote';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import moment from 'moment';
// import { Form, Modal, Spinner } from 'react-bootstrap';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
// import CloseIcon from '@mui/icons-material/Close';
// import { Link } from 'react-router-dom';
// import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
// import FilterListIcon from '@mui/icons-material/FilterList';

// // استيراد مكتبة السحب والإفلات
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import XLSX from '../../utils/excelUtils';
// import axios from 'axios';
// import QuickFilterModal from '../../Pages/QuickFilterModal';
// import { Getalldatasearch_For_Admin } from '../../Redux/Actions/All_Leads_For_Admin_Action';
// import { AssignLeadsModal } from '../../Pages/AssignLeadsModal';
// import { ClientTable2 } from '../ClientTable2';
// import { Notify } from '../../Utility/Notify';
// import { ShowClientsActionsAdvanced } from '../../Pages/ShowClientsActionsAdvanced';
// import { LeadDuplicationModal } from '../../Pages/LeadDuplicationModal';
// import { UpdateClientAction } from '../../Redux/Actions/UsersAction';
// import { db_url } from '../../Api/BaseUrl';
// import { Admin_Report_Model_For_Requested_Data } from './Admin_Report_Model_For_Requested_Data';

// // PhoneCell Component
// const PhoneCell = React.memo(({ user, mode }) => {
//   const [showFullNumber, setShowFullNumber] = useState(false);

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'left',
//         gap: 0.5,
//       }}
//       onMouseEnter={() => setShowFullNumber(true)}
//       onMouseLeave={() => setShowFullNumber(false)}
//     >
//       {/* Phone Number - Show first 5 digits normally, full number on hover */}
//       {user.phone && (
//         <Typography
//           variant="body2"
//           sx={{
//             cursor: 'pointer',
//             padding: '4px 8px',
//             borderRadius: '4px',
//             backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//             transition: 'all 0.2s ease-in-out',
//             fontFamily: 'monospace',
//             fontWeight: '500',
//             minHeight: '32px',
//             display: 'flex',
//             alignItems: 'left',
//             justifyContent: 'left',
//             minWidth: '80px',
//             '&:hover': {
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
//             },
//           }}
//         >
//           {showFullNumber ? user.phone : `${user.phone.substring(0, 5)}...`}
//         </Typography>
//       )}

//       {/* Icons Container */}
//       <Box sx={{ display: 'flex', alignItems: 'left', gap: 1 }}>
//         {/* WhatsApp Icon */}
//         <IconButton
//           size="small"
//           onClick={(e) => {
//             e.stopPropagation();
//             if (user.phone) {
//               const whatsappUrl = `https://wa.me/${user.phone.replace(/\D/g, '')}`;
//               window.open(whatsappUrl, '_blank');
//             }
//           }}
//           sx={{
//             color: '#25D366',
//             backgroundColor:
//               mode === 'dark' ? 'rgba(37, 211, 102, 0.1)' : 'rgba(37, 211, 102, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(37, 211, 102, 0.2)' : 'rgba(37, 211, 102, 0.2)',
//             },
//           }}
//           disabled={!user.phone}
//         >
//           <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.189-1.248-6.189-3.515-8.452" />
//           </svg>
//         </IconButton>

//         {/* Phone Icon */}
//         <IconButton
//           size="small"
//           onClick={(e) => {
//             e.stopPropagation();
//             if (user.phone) {
//               window.open(`tel:${user.phone}`);
//             }
//           }}
//           sx={{
//             color: '#1976d2',
//             backgroundColor:
//               mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(25, 118, 210, 0.2)' : 'rgba(25, 118, 210, 0.2)',
//             },
//           }}
//           disabled={!user.phone}
//         >
//           <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
//           </svg>
//         </IconButton>
//       </Box>
//     </Box>
//   );
// });

// export const AdminAllLeadsCRMData = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const location = useLocation();

//   const dispatch = useDispatch();
//   const [loadinggetdtaa, setloadinggetdata] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(25);
//   const [goToPageDialog, setGoToPageDialog] = useState(false);
//   const [pageInput, setPageInput] = useState('');
//   const [tableSettingsOpen, setTableSettingsOpen] = useState(false);
//   const [message, setMessage] = useState('');
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [expandedRows, setExpandedRows] = useState({});
//   // في الـ component state أضيف:
//   const [hoveredLeadId, setHoveredLeadId] = useState(null);
//   const [loadingComments, setLoadingComments] = useState(false);
//   const [comments, setComments] = useState([]);
//   // 🔄 إضافة الـ refs للإدارة الذكية للطلبات
//   const isFetchingRef = useRef(false);
//   const currentStageRef = useRef('');
//   const pendingRequestRef = useRef(null);
//   const initialLoadDoneRef = useRef(false);

//   // get all information about logged user
//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   // Assign & Transfer States
//   const [showAssignModal, setShowAssignModal] = useState(false);
//   const [openassign, setOpenassign] = useState(false);

//   // 🔍 نأخذ الـ search من localStorage اللي بيتحكم فيه الـ navbar
//   const [searchQuery, setSearchQuery] = useState(localStorage.getItem('mainsearchstorage') || '');

//   // 📋 Selection State
//   const [selectedLeads, setSelectedLeads] = useState(() => {
//     const saved = localStorage.getItem('selectedleeds');
//     return saved ? JSON.parse(saved) : [];
//   });
//   const [selectAll, setSelectAll] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);

//   // 📊 Default table configuration
//   const defaultTableConfig = {
//     columns: [
//       { key: 'selection', label: '', visible: true, width: 60 },
//       { key: 'duplicate', label: 'Duplicate', visible: true, width: 120 },
//       { key: 'name', label: 'Name', visible: true, width: 180 },
//       { key: 'phone', label: 'Phone', visible: true, width: 140 },
//       { key: 'developer', label: 'Developer', visible: true, width: 120 },
//       { key: 'project', label: 'Project', visible: true, width: 150 },
//       { key: 'campaign', label: 'Campaign', visible: true, width: 150 },
//       { key: 'Channal', label: 'Channal', visible: true, width: 150 },
//       { key: 'sales', label: 'Sales', visible: true, width: 150 },
//       { key: 'lastComment', label: 'Last Comment', visible: true, width: 80 }, // ⬅️ الجديدة
//       { key: 'stage', label: 'Stage', visible: true, width: 180 },
//       { key: 'status', label: 'Status', visible: true, width: 100 },
//       { key: 'Creation_date', label: 'Creation Date', visible: true, width: 180 },
//       { key: 'AddedBy', label: 'Added By', visible: true, width: 200 },
//       { key: 'actions', label: 'Actions', visible: true, width: 120 },
//     ],
//     columnOrder: [
//       'selection',
//       'duplicate',
//       'name',
//       'phone',
//       'developer',
//       'project',
//       'campaign',
//       'Channal',
//       'sales',
//       'lastComment',
//       'stage',
//       'status',
//       'Creation_date',
//       'AddedBy',
//       'actions',
//     ],
//     whiteHeaders: true,
//   };

//   // 📊 Table customization state - Load from localStorage
//   const [tableConfig, setTableConfig] = useState(() => {
//     const savedConfig = localStorage.getItem('leadsTableConfig');
//     return savedConfig ? JSON.parse(savedConfig) : defaultTableConfig;
//   });

//   // 💾 Save table config to localStorage whenever it changes
//   useEffect(() => {
//     localStorage.setItem('leadsTableConfig', JSON.stringify(tableConfig));
//   }, [tableConfig]);

//   // 💾 Save selected leads to localStorage
//   useEffect(() => {
//     localStorage.setItem('selectedleeds', JSON.stringify(selectedLeads));
//   }, [selectedLeads]);

//   // 🔔 Show/hide snackbar based on selection
//   useEffect(() => {
//     setSnackbarOpen(selectedLeads.length > 0);
//   }, [selectedLeads]);

//   // Assign & Transfer Functions
//   const handleAssignClick = () => {
//     if (selectedLeads?.length === 0) {
//       console.log('Please select at least one Lead for assignment.');
//       return;
//     }
//     localStorage.setItem('action', 'Assign');
//     setShowAssignModal(true);
//     setOpenassign(false);
//   };

//   const handleTransferClick = () => {
//     if (selectedLeads?.length === 0) {
//       console.log('Please select at least one Lead for transfer.');
//       return;
//     }

//     const selectedLeadsData =
//       resleads?.data?.filter((lead) => selectedLeads.includes(lead._id)) || [];
//     const allAreTransfer = selectedLeadsData.every((lead) => lead.stage?.name === 'Transfer');

//     if (!allAreTransfer) {
//       console.log('This icon is for Transfer Leads only.');
//       return;
//     }

//     localStorage.setItem('action', 'Transfer');
//     setShowAssignModal(true);
//     setOpenassign(false);
//   };

//   const handleCloseAssignModal = () => {
//     setShowAssignModal(false);
//   };

//   const handleCloseassign = () => {
//     setOpenassign(false);
//   };

//   const [showmoredelete, setshowmoredelete] = useState(false);

//   const handleClosemoredelete = () => {
//     setshowmoredelete(false);
//   };

//   const handleShowmoredelete = () => {
//     setshowmoredelete(true);
//   };

//   const searchParams2 = new URLSearchParams(location.search);
//   const duplicates2 = searchParams2.get('duplicates');
//   const ignoreduplicate2 = searchParams2.get('ignoreduplicate');
//   const handleignoreupdate = async () => {
//     if (selectedLeads?.length === 0) {
//       Notify('error', 'Please select at least one Lead to ignore duplicate.', 'error');
//       return;
//     }

//     try {
//       // حفظ الباراميترات الحالية قبل التحديث
//       const searchParams = new URLSearchParams(location.search);
//       const currentStage = searchParams.get('stage');
//       const currentDuplicates = searchParams.get('duplicates');
//       const currentIgnoreDuplicate = searchParams.get('ignoreduplicate');

//       // تنفيذ عملية ignore لجميع الـ leads المحددة
//       const ignorePromises = selectedLeads?.map((leadId) =>
//         dispatch(
//           UpdateClientAction(leadId, {
//             ignoredublicate: 'false',
//           }),
//         ),
//       );

//       await Promise.all(ignorePromises);

//       Notify('success', 'Leads ignored duplicate successfully', 'success');

//       // 🔄 إعادة تحميل البيانات بنفس الباراميترات الحالية
//       // مع التأكد من إعادة تحميل الصفحة الأولى
//       setCurrentPage(1);

//       // استدعاء get_all_Leads بنفس الفلاتر الحالية
//       get_all_Leads(
//         1, // الصفحة الأولى
//         itemsPerPage,
//         searchQuery,
//         currentStage,
//         currentDuplicates,
//         appliedFilters, // 🔥 أضف appliedFilters هنا أيضاً
//       );

//       // مسح الـ selection بعد العملية
//       setSelectedLeads([]);
//       setSelectAll(false);
//     } catch (error) {
//       console.error('Error ignoring duplicates:', error);
//       Notify('error', 'Failed to ignore duplicates', 'error');
//     }
//   };
//   // Action buttons for Snackbar

//   const action = (
//     <React.Fragment>
//       {/* زر Ignore Duplicate - يظهر فقط في صفحة الـ duplicates */}
//       {duplicates2 === 'true' && ignoreduplicate2 === 'true' && (
//         <Tooltip title="Ignore Duplicate Leads">
//           <IconButton
//             size="small"
//             onClick={handleignoreupdate}
//             sx={{
//               color: '#9c27b0', // لون بنفسجي
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(156, 39, 176, 0.1)' : 'rgba(156, 39, 176, 0.1)',
//               '&:hover': {
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.2)',
//               },
//               marginRight: 1,
//             }}
//           >
//             <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M19 13H5v-2h14v2z" />
//             </svg>
//           </IconButton>
//         </Tooltip>
//       )}

//       <Tooltip title="Assign Leads">
//         <IconButton
//           size="small"
//           onClick={handleAssignClick}
//           sx={{
//             color: '#4caf50',
//             backgroundColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.1)' : 'rgba(76, 175, 80, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(76, 175, 80, 0.2)' : 'rgba(76, 175, 80, 0.2)',
//             },
//             marginRight: 1,
//           }}
//         >
//           <PersonAddIcon fontSize="small" />
//         </IconButton>
//       </Tooltip>

//       <Tooltip title="Transfer Leads">
//         <IconButton
//           size="small"
//           onClick={handleTransferClick}
//           sx={{
//             color: '#ff9800',
//             backgroundColor: mode === 'dark' ? 'rgba(255, 152, 0, 0.1)' : 'rgba(255, 152, 0, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(255, 152, 0, 0.2)' : 'rgba(255, 152, 0, 0.2)',
//             },
//             marginRight: 1,
//           }}
//         >
//           <TransferWithinAStationIcon fontSize="small" />
//         </IconButton>
//       </Tooltip>

//       <Tooltip title="Delete Leads">
//         <IconButton
//           size="small"
//           onClick={handleShowmoredelete}
//           sx={{
//             color: '#d32f2f',
//             backgroundColor: mode === 'dark' ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.2)',
//             },
//             marginRight: 1,
//           }}
//         >
//           <DeleteOutlineOutlinedIcon fontSize="small" />
//         </IconButton>
//       </Tooltip>

//       <Button
//         size="small"
//         onClick={() => setSelectedLeads([])}
//         sx={{
//           color: 'white',
//           '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
//         }}
//         className="mx-2"
//       >
//         Clear
//       </Button>
//     </React.Fragment>
//   );

//   // 🔍 دالة ذكية للبحث تعتمد على نوع الـ input
//   const getSearchQuery = (search) => {
//     if (!search) return '';

//     const cleanSearch = search.trim();

//     // إذا كان إيميل واضح
//     if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanSearch)) {
//       return `email=${encodeURIComponent(cleanSearch)}`;
//     }

//     // إذا كان رقم تليفون
//     if (/^\+?[\d\s\-\(\)]+$/.test(cleanSearch)) {
//       return `keyword=${encodeURIComponent(cleanSearch)}`;
//     }

//     // أي شيء آخر نستخدم keyword علشان يدور في name و phone
//     return `keyword=${encodeURIComponent(cleanSearch)}`;
//   };

//   const [appliedFilters, setAppliedFilters] = useState({});

//   const handleApplyFilters = (filters) => {
//     console.log('🎯 Received filters:', filters);
//     setAppliedFilters(filters);
//     setCurrentPage(1);

//     // البحث باستخدام الفلاتر الجديدة
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates, filters);
//   };

//   // 🎯 دالة التحميل الرئيسية المعدلة
//   // 🎯 دالة التحميل الرئيسية المعدلة مع دعم oldstage
//   const get_all_Leads = async (
//     page = 1,
//     limit = itemsPerPage,
//     search = '',
//     stage = '',
//     duplicates = '',
//     filters = {},
//   ) => {
//     setloadinggetdata(true);

//     let query = `leadisactive=true&limit=${limit}&page=${page}&sort=-date&data=false&transferefromdata=false`;

//     // 🔍 إضافة الـ search إذا موجود
//     if (search) {
//       const searchParam = getSearchQuery(search);
//       console.log('🔍 Using keyword search:', searchParam);
//       query += `&${searchParam}`;
//     }

//     // 🎯 إضافة الـ stage ID إذا موجود في الـ URL (current stage)
//     if (stage) {
//       query += `&stage=${encodeURIComponent(stage)}`;
//       console.log('🎯 Filtering by current stage ID:', stage);
//     }

//     // 🔄 إضافة الـ duplicates إذا موجود في الـ URL
//     // 🔄 إضافة الـ duplicates إذا موجود في الـ URL
//     if (duplicates === 'true') {
//       // 🔥 أضف ignoreduplicate مع duplicates
//       query += `&duplicates=true&ignoreduplicate=true`;
//       console.log('🔄 Loading duplicates with ignoreduplicate flag');
//     }

//     // 🎛️ إضافة الفلاتر من الـ QuickFilterModal
//     if (filters && Object.keys(filters).length > 0) {
//       console.log('🎛️ Applying quick filters:', filters);

//       // معالجة كل نوع من الفلاتر

//       // الفلاتر النصية (budget)
//       if (filters.budget) {
//         query += `&budget=${encodeURIComponent(filters.budget)}`;
//       }

//       // فلاتر المصفوفات (stage, sales, channel, etc.)
//       const arrayFilters = [
//         'stage',
//         'sales',
//         'chanel',
//         'campaign',
//         'project',
//         'developer',
//         'addby',
//       ];

//       arrayFilters.forEach((filterKey) => {
//         if (filters[filterKey] && filters[filterKey].length > 0) {
//           // إرسال الـ IDs للمصفوفات
//           const ids = filters[filterKey]
//             .map((item) => item.id || item._id)
//             .filter((id) => id)
//             .join(',');

//           if (ids) {
//             query += `&${filterKey}=${encodeURIComponent(ids)}`;
//           }
//         }
//       });

//       // 🔥🔥🔥 إضافة الـ Old Stage إذا كان مختار
//       if (filters.oldstage && filters.oldstage.length > 0) {
//         const oldStageIds = filters.oldstage
//           .map((item) => item.id || item._id)
//           .filter((id) => id)
//           .join(',');

//         if (oldStageIds) {
//           query += `&oldstage=${encodeURIComponent(oldStageIds)}`;
//           console.log('📜 Adding oldstage filter:', oldStageIds);
//         }
//       }

//       // 🔥🔥🔥 إضافة الـ Assigned From إذا كان مختار
//       if (filters.assignedFrom && filters.assignedFrom.length > 0) {
//         const assignedFromIds = filters.assignedFrom
//           .map((item) => item.id || item._id)
//           .filter((id) => id)
//           .join(',');

//         if (assignedFromIds) {
//           query += `&assignedFrom=${encodeURIComponent(assignedFromIds)}`;
//           console.log('👤 Adding assignedFrom filter:', assignedFromIds);
//         }
//       }

//       // 🔥🔥🔥 إضافة الـ Assigned To إذا كان مختار
//       if (filters.assignedTo && filters.assignedTo.length > 0) {
//         const assignedToIds = filters.assignedTo
//           .map((item) => item.id || item._id)
//           .filter((id) => id)
//           .join(',');

//         if (assignedToIds) {
//           query += `&assignedTo=${encodeURIComponent(assignedToIds)}`;
//           console.log('🎯 Adding assignedTo filter:', assignedToIds);
//         }
//       }

//       // فلاتر التاريخ
//       if (filters.createdAt) {
//         if (filters.createdAt.from) {
//           query += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
//         }
//         if (filters.createdAt.to) {
//           query += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
//         }
//       }

//       // 🔥🔥🔥 إضافة فلتر Stage Date Range إذا كان مختار
//       if (filters.stagedateupdated) {
//         if (filters.stagedateupdated.from) {
//           query += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
//           console.log('📅 Adding stageDateFrom filter:', filters.stagedateupdated.from);
//         }
//         if (filters.stagedateupdated.to) {
//           query += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
//           console.log('📅 Adding stageDateTo filter:', filters.stagedateupdated.to);
//         }
//       }
//     }

//     console.log('📦 Final query:', query);

//     try {
//       await dispatch(Getalldatasearch_For_Admin(query));
//     } catch (error) {
//       console.error('❌ Search failed:', error);
//     } finally {
//       setloadinggetdata(false);
//     }
//   };

//   // 🔄 تحديث الـ effect الرئيسي لدعم الفلاتر
//   // 🔄 تحديث الـ effect الرئيسي لدعم الفلاتر والـ oldstage
//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');
//     const newStage = stage || duplicates || 'all';

//     console.log('🎯 تحقق من تغيير الـ URL:', {
//       oldStage: currentStageRef.current,
//       newStage: newStage,
//       searchQuery: searchQuery,
//       appliedFilters: appliedFilters, // 🔥 الفلاتر المطبقة
//     });

//     if (currentStageRef.current !== newStage || !initialLoadDoneRef.current) {
//       console.log('🔄 تغيير في الـ URL - إعادة التحميل');

//       if (pendingRequestRef.current) {
//         clearTimeout(pendingRequestRef.current);
//         pendingRequestRef.current = null;
//       }

//       setCurrentPage(1);
//       currentStageRef.current = newStage;

//       pendingRequestRef.current = setTimeout(() => {
//         get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates, appliedFilters);
//         initialLoadDoneRef.current = true;
//       }, 300);
//     }

//     return () => {
//       if (pendingRequestRef.current) {
//         clearTimeout(pendingRequestRef.current);
//       }
//     };
//   }, [location.search, searchQuery, appliedFilters]); // 🔥 أضف appliedFilters هنا
//   // 🔍 استماع لتغييرات الـ search من الـ navbar
//   useEffect(() => {
//     const handleSearchUpdate = () => {
//       const newSearch = localStorage.getItem('mainsearchstorage') || '';
//       setSearchQuery(newSearch);
//       setCurrentPage(1);

//       const searchParams = new URLSearchParams(location.search);
//       const stage = searchParams.get('stage');
//       const duplicates = searchParams.get('duplicates');

//       get_all_Leads(1, itemsPerPage, newSearch, stage, duplicates);
//     };

//     window.addEventListener('mainsearchupdated', handleSearchUpdate);

//     return () => {
//       window.removeEventListener('mainsearchupdated', handleSearchUpdate);
//     };
//   }, [itemsPerPage, location.search]);

//   // التحميل الأولي
//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates);
//     currentStageRef.current = stage || duplicates || 'all';
//   }, []);

//   const handledeleteallselectedleads = async () => {
//     if (selectedLeads?.length === 0) {
//       Notify('error', 'Please select at least one Lead to delete.', 'error');
//       return;
//     }

//     const deletePromises = selectedLeads?.map((leadId) =>
//       dispatch(
//         UpdateClientAction(leadId, {
//           leadisactive: 'false',
//         }),
//       ),
//     );

//     await Promise.all(deletePromises);

//     Notify('success', 'Leads deleted successfully', 'success');
//     handleClosemoredelete();

//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');
//     setSelectedLeads([]);
//     get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates);
//   };

//   const resleads = useSelector((state) => state.All_Leads_For_Admin_Reducer.AllLeads);
//   // ==========================================================================
//   // 📋 Selection Functions
//   // const handleSelectLead = (leadId) => {
//   //   setSelectedLeads(prev => {
//   //     if (prev.includes(leadId)) {
//   //       return prev.filter(id => id !== leadId);
//   //     } else {
//   //       return [...prev, leadId];
//   //     }
//   //   });
//   // };

//   // const handleSelectAll = () => {
//   //   if (selectAll) {
//   //     setSelectedLeads([]);
//   //     setSelectAll(false);
//   //   } else {
//   //     const allLeadIds = resleads?.data?.map(lead => lead._id) || [];
//   //     setSelectedLeads(allLeadIds);
//   //     setSelectAll(true);
//   //   }
//   // };
//   // ================================================================
//   // ===================================================================
//   const handleSelectLead = (leadId) => {
//     // نحفظ موقع الـ scroll الحالي
//     const currentScroll = window.scrollY || document.documentElement.scrollTop;

//     setSelectedLeads((prev) => {
//       if (prev.includes(leadId)) {
//         return prev.filter((id) => id !== leadId);
//       } else {
//         return [...prev, leadId];
//       }
//     });

//     // نرجع لنفس المكان بعد الـ update
//     setTimeout(() => {
//       window.scrollTo(0, currentScroll);
//     }, 10);
//   };

//   // 3. نفس الشيء في handleSelectAll
//   const handleSelectAll = () => {
//     const currentScroll = window.scrollY || document.documentElement.scrollTop;

//     if (selectAll) {
//       setSelectedLeads([]);
//       setSelectAll(false);
//     } else {
//       const allLeadIds = resleads?.data?.map((lead) => lead._id) || [];
//       setSelectedLeads(allLeadIds);
//       setSelectAll(true);
//     }

//     setTimeout(() => {
//       window.scrollTo(0, currentScroll);
//     }, 10);
//   };

//   const isLeadSelected = (leadId) => {
//     return selectedLeads.includes(leadId);
//   };

//   const handleClearSelection = () => {
//     setSelectedLeads([]);
//     setSelectAll(false);
//   };

//   // 📄 Pagination Functions المعدلة
//   const handlePageChange = (event, value) => {
//     setCurrentPage(value);
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     get_all_Leads(value, itemsPerPage, searchQuery, stage, duplicates, appliedFilters);
//   };

//   const handleItemsPerPageChange = (event) => {
//     const newLimit = event.target.value;
//     setItemsPerPage(newLimit);
//     setCurrentPage(1); // نرجع للصفحة الأولى عند تغيير الـ limit
//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     get_all_Leads(1, newLimit, searchQuery, stage, duplicates, appliedFilters);
//   };

//   const handleOpenGoToPage = () => {
//     setPageInput('');
//     setGoToPageDialog(true);
//   };

//   const handleCloseGoToPage = () => {
//     setGoToPageDialog(false);
//   };

//   const handleGoToPage = () => {
//     const pageNum = parseInt(pageInput);
//     if (pageNum && pageNum >= 1 && pageNum <= resleads?.pagination?.NumberOfPages) {
//       setCurrentPage(pageNum);
//       const searchParams = new URLSearchParams(location.search);
//       const stage = searchParams.get('stage');
//       const duplicates = searchParams.get('duplicates');
//       get_all_Leads(pageNum, itemsPerPage, searchQuery, stage, duplicates);
//       setGoToPageDialog(false);
//     }
//   };

//   // 🔄 دالة التحديث اليدوي الشامل
//   const handleRefreshData = () => {
//     console.log('🔄 تحديث يدوي شامل');

//     const searchParams = new URLSearchParams(location.search);
//     const stage = searchParams.get('stage');
//     const duplicates = searchParams.get('duplicates');

//     // reset كامل
//     setCurrentPage(1);
//     isFetchingRef.current = false;
//     initialLoadDoneRef.current = false;
//     currentStageRef.current = stage || duplicates || 'all';
//     setSelectedLeads([]);
//     setSelectAll(false);

//     get_all_Leads(1, itemsPerPage, searchQuery, stage, duplicates);
//   };

//   const downloadExcelTemplate = () => {
//     // إنشاء البيانات الأساسية للقالب
//     const templateData = [
//       {
//         name: 'Ahmed Hassan',
//         phone: '+971501234567',
//         email: 'ahmed@email.com',
//         project_name: 'Dubai Hills',
//         sales_name: 'Mohamed Ali',
//         chanel_name: '008 | A',
//         communication_way: 'Call',
//         stage_name: 'Follow UP',
//         campaign_name: 'Summer Campaign',
//         addby_name: 'Joun',
//         updatedby_name: 'Joun',
//         budget: '1500000',
//         leedtype: 'Cold',
//         stagedateupdated: '2024-03-15',
//         dayonly: '2024-03-15',
//         last_stage_date_updated: '2024-03-15',
//         creation_date: '2024-01-10',
//         Last_Date_Assigned: '2024-03-01',
//       },
//       {
//         name: 'Sarah Johnson',
//         phone: '+971502345678',
//         email: 'sarah@email.com',
//         project_name: 'Palm Jumeirah',
//         sales_name: 'Fatima Ahmed',
//         chanel_name: '005 |A',
//         communication_way: 'Whatsapp',
//         stage_name: 'Pending',
//         campaign_name: 'Luxury Homes',
//         addby_name: 'Johan De',
//         updatedby_name: 'Johan De',
//         budget: '2800000',
//         leedtype: 'Cold',
//         stagedateupdated: '2024-03-10',
//         dayonly: '2024-03-10',
//         last_stage_date_updated: '2024-03-10',
//         creation_date: '2024-01-25',
//         Last_Date_Assigned: '2024-02-15',
//       },
//     ];

//     // إنشاء ورقة Excel
//     const ws = XLSX.utils.json_to_sheet(templateData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Leads Template');

//     // تنزيل الملف
//     XLSX.writeFile(wb, 'Leads_Import_Template.xlsx');

//     // إذا لم يكن XLSX متاحاً، عرض رسالة
//     console.log('Template downloaded successfully');

//     // يمكنك أيضاً استخدام:
//     // window.open('/api/download-template', '_blank');
//   };

//   const [openimport2, setopenimport2] = useState(false);
//   const [fileimport2, setFileimport2] = useState(null);
//   const [previewData, setPreviewData] = useState([]);
//   const [loadingimprt2, setLoadingimort2] = useState(false);
//   const [resultimport2, setResultimport2] = useState(null);
//   const [errorimport2, setErrorimport2] = useState(null);
// const [adminReportDialogOpen, setAdminReportDialogOpen] = useState(false);

//   const handleOpenimport2 = () => setopenimport2(true);
//   const handleCloseimport2 = () => {
//     setopenimport2(false);
//     setFileimport2(null);
//     setPreviewData([]);
//     setResultimport2(null);
//     setErrorimport2(null);
//   };

//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setFileimport2(file);
//     setResultimport2(null);
//     setErrorimport2(null);

//     const reader = new FileReader();
//     reader.onload = async (e) => {
//       const data = e.target.result;
//       const workbook = await XLSX.readAsync(data);
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//       const json = XLSX.utils.sheet_to_json(sheet);
//       setPreviewData(json);
//     };
//     reader.readAsBinaryString(file);
//   }; //     const file = e.target.files[0];
//   //     if (!file) return;

//   //     setFileimport2(file);
//   //     setResultimport2(null);
//   //     setErrorimport2(null);

//   //     const reader = new FileReader();
//   //     reader.onload = (e) => {
//   //       const data = e.target.result;
//   //       const workbook = XLSX.read(data, { type: 'binary' });
//   //       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//   //       const json = XLSX.utils.sheet_to_json(sheet);
//   //       setPreviewData(json);
//   //     };
//   //     reader.readAsBinaryString(file);
//   //   };

//   const onUploadimportleads2 = async () => {
//     if (!fileimport2) {
//       alert('Please select a file first');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', fileimport2);

//     setLoadingimort2(true);
//     try {
//       const res = await axios.post(`${db_url}api/v1/users/import-leads`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       setResultimport2(res.data);
//     } catch (err) {
//       setErrorimport2(err.response?.data || { message: err.message });
//     }
//     setLoadingimort2(false);
//     get_all_Leads(1, itemsPerPage, searchQuery);
//   };

//   const [filteredUsers, setFilteredUsers] = useState([]);

//   // في useEffect عندما البيانات تتحمل
//   useEffect(() => {
//     if (resleads?.data) {
//       setFilteredUsers(resleads.data);
//     }
//   }, [resleads]);

//   const exportFilteredToExcel = () => {
//     // استخدام الـ filteredUsers أو resleads.data
//     const usersToExport = filteredUsers.length > 0 ? filteredUsers : resleads?.data || [];

//     if (usersToExport.length === 0) {
//       Notify('warning', 'No data to export.', 'warning');
//       return;
//     }

//     // معالجة البيانات قبل التصدير
//     const dataToExport = usersToExport.map((user) => ({
//       // "ID": user._id,
//       Name: user.name || '',
//       Email: user.email || '',
//       Phone: user.phone || '',
//       'Phone 2': user.phonenumber2 || '',
//       WhatsApp: user.whatsappnumber || '',
//       Project: user.project?.name || 'N/A',
//       Developer: user.project?.developer?.name || 'N/A',
//       Campaign: user.campaign?.CampainName || 'N/A',
//       Channel: user.chanel?.name || 'N/A',
//       'Sales Person': user.sales?.name || 'N/A',
//       Stage: user.stage?.name || 'N/A',
//       'Stage Date': user.stagedateupdated
//         ? moment(user.stagedateupdated).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
//         : '',
//       Status: user.leadisactive === 'true' ? 'Active' : 'Inactive',
//       Notes: user.notes || '',
//       Budget: user.budget || '',
//       'Assigned To': user.sales?.name || '',
//       'Assigned From': user.assignfrom?.name || '',
//       'Added By': user.addby?.name || 'N/A',
//       'Creation Date': user.date
//         ? moment(user.date).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
//         : '',
//       'Last Comment': user.lastComment?.firstcomment?.text || '',
//       'Action Plan': user.lastComment?.secondcomment?.text || '',
//       'Comment Date': user.lastComment?.firstcomment?.date
//         ? moment(user.lastComment.firstcomment.date).format('DD/MM/YYYY h:mm A')
//         : '',
//     }));

//     // إعداد الـ Excel
//     const ws = XLSX.utils.json_to_sheet(dataToExport);
//     const wb = XLSX.utils.book_new();

//     // تحديد عرض الأعمدة
//     const wscols = [
//       { wch: 25 }, // ID
//       { wch: 20 }, // Name
//       { wch: 25 }, // Email
//       { wch: 15 }, // Phone
//       { wch: 15 }, // Phone 2
//       { wch: 15 }, // WhatsApp
//       { wch: 20 }, // Project
//       { wch: 20 }, // Developer
//       { wch: 20 }, // Campaign
//       { wch: 15 }, // Channel
//       { wch: 20 }, // Sales Person
//       { wch: 15 }, // Stage
//       { wch: 20 }, // Stage Date
//       { wch: 10 }, // Status
//       { wch: 30 }, // Notes
//       { wch: 15 }, // Budget
//       { wch: 20 }, // Assigned To
//       { wch: 20 }, // Assigned From
//       { wch: 20 }, // Added By
//       { wch: 20 }, // Creation Date
//       { wch: 40 }, // Last Comment
//       { wch: 40 }, // Action Plan
//       { wch: 20 }, // Comment Date
//     ];

//     ws['!cols'] = wscols;

//     XLSX.utils.book_append_sheet(wb, ws, 'Filtered Leads Data');

//     // إنشاء اسم للملف مع التاريخ
//     const fileName = `Leads_Export_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
//     XLSX.writeFile(wb, fileName);

//     Notify('success', `Exported ${usersToExport.length} leads to Excel!`, 'success');
//   };

//   const exportFilteredLeadsWithAllComments = async () => {
//     // التأكد من وجود بيانات لتصديرها
//     // if (!resleads?.data || resleads.data.length === 0) {
//     //   Notify("warning", "No leads to export.", "warning");
//     //   return;
//     // }

//     Notify('info', 'Preparing data... This may take a moment.', 'info');

//     try {
//       // 1. جلب جميع الإجراءات (التي تحتوي على التعليقات) مرة واحدة
//       const response = await axios.get(`${db_url}api/v1/Action`);
//       const allActions = response.data.data;

//       // 2. معالجة البيانات لتضمين التعليقات
//       const dataToExport = resleads.data.map((lead) => {
//         // البحث عن الإجراءات الخاصة بهذا الـ lead
//         const leadActions = allActions.filter((action) => action.leed?._id === lead._id);

//         // تجميع كل التعليقات الخاصة بالـ lead من جميع الإجراءات
//         const allLeadComments = leadActions.flatMap((action) => action.Comments || []);

//         // ترتيب التعليقات من الأقدم إلى الأحدث
//         const sortedComments = allLeadComments.sort(
//           (a, b) => new Date(a.stageDate || a.createdAt) - new Date(b.stageDate || b.createdAt),
//         );

//         // 3. تنسيق جميع التعليقات في نص واحد قابل للقراءة
//         const formattedComments = sortedComments
//           .map((comment, index) => {
//             const commentDate = moment(comment.stageDate || comment.createdAt).format(
//               'DD/MM/YYYY h:mm A',
//             );
//             const stageName = comment.stage?.name || 'N/A';
//             const salesName = comment.sales?.name || 'N/A';
//             const firstComment = comment.firstcomment?.text || 'No text';
//             const secondComment = comment.secondcomment?.text || 'No text';

//             return `(${index + 1}) [${commentDate}] - [Stage: ${stageName}] - [By: ${salesName}]\nComment: ${firstComment}\nNext Action: ${secondComment}\n------------------`;
//           })
//           .join('\n\n'); // فصل بين كل تعليق والآخر بأسطر فارغة

//         // 4. إرجاع كائن جديد يحتوي على بيانات الـ lead والتعليقات المنسقة
//         return {
//           // "ID": lead._id,
//           Name: lead.name || '',
//           Email: lead.email || '',
//           Phone: lead.phone || '',
//           Project: lead.project?.name || 'N/A',
//           Developer: lead.project?.developer?.name || 'N/A',
//           Campaign: lead.campaign?.CampainName || 'N/A',
//           Channel: lead.chanel?.name || 'N/A',
//           'Sales Person': lead.sales?.name || 'N/A',
//           Stage: lead.stage?.name || 'N/A',
//           'Stage Date': lead.stagedateupdated
//             ? moment(lead.stagedateupdated).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
//             : '',
//           Status: lead.leadisactive === 'true' ? 'Active' : 'Inactive',
//           Notes: lead.notes || '',
//           Budget: lead.budget || '',
//           'Assigned To': lead.sales?.name || '',
//           'Assigned From': lead.assignfrom?.name || '',
//           'Added By': lead.addby?.name || 'N/A',
//           'Creation Date': lead.date
//             ? moment(lead.date).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A')
//             : '',
//           'Total Comments': sortedComments.length,
//           'All Comments': formattedComments || 'No Comments Found',
//         };
//       });

//       // 5. تصدير البيانات إلى ملف Excel
//       const worksheet = XLSX.utils.json_to_sheet(dataToExport);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads with All Comments');

//       // ضبط عرض الأعمدة تلقائيًا
//       const wscols = [
//         { wch: 25 }, // ID
//         { wch: 20 }, // Name
//         { wch: 25 }, // Email
//         { wch: 15 }, // Phone
//         { wch: 20 }, // Project
//         { wch: 20 }, // Developer
//         { wch: 20 }, // Campaign
//         { wch: 15 }, // Channel
//         { wch: 20 }, // Sales Person
//         { wch: 15 }, // Stage
//         { wch: 20 }, // Stage Date
//         { wch: 10 }, // Status
//         { wch: 30 }, // Notes
//         { wch: 15 }, // Budget
//         { wch: 20 }, // Assigned To
//         { wch: 20 }, // Assigned From
//         { wch: 20 }, // Added By
//         { wch: 20 }, // Creation Date
//         { wch: 10 }, // Total Comments
//         { wch: 100 }, // All Comments - عرض كبير
//       ];

//       worksheet['!cols'] = wscols;

//       const fileName = `Leads_With_All_Comments_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
//       XLSX.writeFile(workbook, fileName);

//       Notify(
//         'success',
//         `Exported ${resleads.data.length} leads with all comments successfully!`,
//         'success',
//       );
//     } catch (error) {
//       console.error('Export with all comments failed:', error);
//       Notify('error', 'Failed to export data. Please check the console.', 'error');
//     }
//   };

//   // 📊 Table customization functions
//   const toggleColumnVisibility = (columnKey) => {
//     setTableConfig((prev) => ({
//       ...prev,
//       columns: prev.columns.map((col) =>
//         col.key === columnKey ? { ...col, visible: !col.visible } : col,
//       ),
//     }));
//   };

//   const updateColumnWidth = (columnKey, newWidth) => {
//     setTableConfig((prev) => ({
//       ...prev,
//       columns: prev.columns.map((col) =>
//         col.key === columnKey ? { ...col, width: Math.max(80, newWidth) } : col,
//       ),
//     }));
//   };

//   const resetToDefault = () => {
//     setTableConfig(defaultTableConfig);
//   };

//   const handleDragEnd = (result) => {
//     if (!result.destination) return;

//     const items = Array.from(tableConfig.columnOrder);
//     const [reorderedItem] = items.splice(result.source.index, 1);
//     items.splice(result.destination.index, 0, reorderedItem);

//     setTableConfig((prev) => ({
//       ...prev,
//       columnOrder: items,
//     }));
//   };

//   const toggleHeaderColors = () => {
//     setTableConfig((prev) => ({
//       ...prev,
//       whiteHeaders: !prev.whiteHeaders,
//     }));
//   };

//   const [showActions, setShowActions] = useState(false);
//   const [duplicationModal, setDuplicationModal] = useState({
//     open: false,
//     leadId: null,
//     leadName: '',
//   });

//   // دالة علشان تجيب الكومنتس عند الـ hover
//   const handleCommentHover = async (leadId) => {
//     setHoveredLeadId(leadId);
//     setLoadingComments(true);

//     try {
//       // هنا ممكن تجيب الكومنتس من الـ API إذا محتاج
//       // أو تستخدم البيانات اللي موجودة في lastComment
//       setLoadingComments(false);
//     } catch (error) {
//       console.error('Error loading comments:', error);
//       setLoadingComments(false);
//     }
//   };

//   const handleCommentLeave = () => {
//     setHoveredLeadId(null);
//     setComments([]);
//   };

//   const getVisibleColumns = () => {
//     return tableConfig.columnOrder
//       .map((key) => tableConfig.columns.find((col) => col.key === key))
//       .filter((col) => col && col.visible);
//   };

//   // Styled components for better UI
//   const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//       backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
//     },
//     '&:hover': {
//       backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
//     },
//   }));

//   const StatusChip = ({ active }) => (
//     <Chip
//       label={active === 'true' ? 'Active' : 'Inactive'}
//       color={active === 'true' ? 'success' : 'default'}
//       size="small"
//     />
//   );

//   // Function to get initials for avatar
//   const getInitials = (name) => {
//     if (!name) return '?';
//     return name
//       .split(' ')
//       .map((n) => n[0])
//       .join('')
//       .toUpperCase()
//       .substring(0, 2);
//   };

//   // دالة مساعدة لألوان الـ Roles
//   const getRoleColor = (role) => {
//     if (!role) return 'default';

//     const roleColors = {
//       admin: 'error',
//       superadmin: 'error',
//       manager: 'warning',
//       supervisor: 'info',
//       sales: 'success',
//       user: 'default',
//       agent: 'primary',
//     };

//     return roleColors[role.toLowerCase()] || 'default';
//   };

//   // Custom cell renderers
//   const renderCell = (col, user) => {
//     switch (col.key) {
//       case 'selection':
//         return (
//           <Checkbox
//             checked={isLeadSelected(user._id)}
//             onChange={() => handleSelectLead(user._id)}
//             sx={{
//               color: mode === 'dark' ? '#fff' : '#000',
//               '&.Mui-checked': {
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//               },
//             }}
//           />
//         );

//       case 'duplicate':
//         return (
//           <Box sx={{ textAlign: 'center', padding: '8px 4px' }}>
//             <Box
//               onClick={() => {
//                 console.log('Opening duplication modal for:', user._id, user.name);
//                 setDuplicationModal({
//                   open: true,
//                   leadId: user._id,
//                   leadName: user.name,
//                 });
//               }}
//               sx={{
//                 color: '#0f7687',
//                 border: '1px solid #0f7687',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(15, 118, 135, 0.1)' : 'rgba(15, 118, 135, 0.05)',
//                 padding: '4px 8px',
//                 borderRadius: '16px',
//                 fontSize: '12px',
//                 fontWeight: '500',
//                 cursor: 'pointer',
//                 display: 'inline-block',
//                 transition: 'all 0.2s ease-in-out',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(15, 118, 135, 0.2)' : 'rgba(15, 118, 135, 0.1)',
//                 },
//               }}
//             >
//               {user.totalSubmissions
//                 ? `${user.totalSubmissions} Register${user.totalSubmissions > 1 ? 's' : ''}`
//                 : '0 Registers'}
//             </Box>
//           </Box>
//         );

//       case 'name':
//         return (
//           <Box
//             sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer' }}
//             onClick={() => setSelectedLead(user)}
//           >
//             <Avatar
//               sx={{
//                 bgcolor: mode === 'dark' ? 'secondary.main' : 'primary.main',
//                 width: 40,
//                 height: 40,
//               }}
//             >
//               {getInitials(user.name)}
//             </Avatar>
//             <Box>
//               <Typography variant="body1" fontWeight="medium">
//                 {user.name}
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {user.email}
//               </Typography>
//             </Box>
//           </Box>
//         );

//       case 'phone':
//         return <PhoneCell user={user} mode={mode} />;

//       case 'project':
//         return (
//           <Typography variant="body2" fontWeight="medium">
//             {user.project?.name || 'N/A'}
//           </Typography>
//         );

//       case 'developer':
//         return <Typography variant="body2">{user?.project?.developer?.name || 'N/A'}</Typography>;

//       // case 'campaign':
//       //   return (
//       //     <Typography variant="body2">
//       //       {user.campaign?.CampainName || 'N/A'}
//       //     </Typography>
//       //   );

//       case 'campaign':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
//             {/* Campaign Name */}
//             <Typography
//               variant="body2"
//               sx={{
//                 fontWeight: user.campaign?.redirectLink ? '500' : 'normal',
//                 color: user.campaign?.redirectLink ? '#1976d2' : 'inherit',
//               }}
//             >
//               {user.campaign?.CampainName || 'N/A'}
//             </Typography>

//             {/* Icons Row - Only shown if there's a redirect link */}
//             {user.campaign?.redirectLink && (
//               <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                 {/* Copy Link Icon */}
//                 <Tooltip title="Copy Campaign Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       navigator.clipboard.writeText(user.campaign.redirectLink);
//                       Notify('success', 'Campaign link copied to clipboard', 'success');
//                     }}
//                     sx={{
//                       padding: '2px',
//                       minWidth: '24px',
//                       height: '24px',
//                       color: '#666',
//                       '&:hover': {
//                         color: '#1976d2',
//                         backgroundColor: 'rgba(25, 118, 210, 0.1)',
//                       },
//                     }}
//                   >
//                     <ContentCopyIcon sx={{ fontSize: '16px' }} />
//                   </IconButton>
//                 </Tooltip>

//                 {/* Open Link Icon */}
//                 <Tooltip title="Open Campaign Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       window.open(user.campaign.redirectLink, '_blank', 'noopener,noreferrer');
//                     }}
//                     sx={{
//                       padding: '2px',
//                       minWidth: '24px',
//                       height: '24px',
//                       color: '#666',
//                       '&:hover': {
//                         color: '#2e7d32',
//                         backgroundColor: 'rgba(46, 125, 50, 0.1)',
//                       },
//                     }}
//                   >
//                     <OpenInNewIcon sx={{ fontSize: '16px' }} />
//                   </IconButton>
//                 </Tooltip>

//                 {/* Optional: Show truncated link */}
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: '#666',
//                     ml: 0.5,
//                     flex: 1,
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     whiteSpace: 'nowrap',
//                   }}
//                   title={user.campaign.redirectLink}
//                 >
//                   {user.campaign.redirectLink.length > 30
//                     ? `${user.campaign.redirectLink.substring(0, 30)}...`
//                     : user.campaign.redirectLink}
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//         );
//         return (
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Typography variant="body2">{user.campaign?.CampainName || 'N/A'}</Typography>

//             {user.campaign?.redirectLink && (
//               <>
//                 {/* Copy Link Icon */}
//                 <Tooltip title="Copy Campaign Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       navigator.clipboard.writeText(user.campaign.redirectLink);
//                       // يمكنك إضافة notifcation هنا
//                       Notify('success', 'Link copied to clipboard', 'success');
//                     }}
//                     sx={{
//                       padding: '4px',
//                       color: '#1976d2',
//                       '&:hover': {
//                         backgroundColor: 'rgba(25, 118, 210, 0.1)',
//                       },
//                     }}
//                   >
//                     <ContentCopyIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>

//                 {/* Open Link Icon */}
//                 <Tooltip title="Open Campaign Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       window.open(user.campaign.redirectLink, '_blank', 'noopener,noreferrer');
//                     }}
//                     sx={{
//                       padding: '4px',
//                       color: '#2e7d32',
//                       '&:hover': {
//                         backgroundColor: 'rgba(46, 125, 50, 0.1)',
//                       },
//                     }}
//                   >
//                     <OpenInNewIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//               </>
//             )}
//           </Box>
//         );

//       case 'Channal':
//         return <Typography variant="body2">{user.chanel?.name || 'N/A'}</Typography>;

//       //       // case 'sales':
//       //         return (
//       //           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//       //             {/* Sales Name with Loading */}
//       //             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//       //    <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//       //   {user?.assigntype === true
//       //     ? (
//       //       <Box component="span" sx={{ fontWeight: 'bold', color: 'red' }}>
//       //         Team: {user.sales?.name || 'N/A'}
//       //       </Box>
//       //     )
//       //     : user.sales?.name || 'N/A'
//       //   }
//       // </Typography>

//       //               {/* Loading dots when assign is true */}
//       //               {user.assign === true && (
//       //                 <Box sx={{ display: 'flex', gap: 0.5 }}>
//       //                   {[1, 2, 3].map((dot) => (
//       //                     <Box
//       //                       key={dot}
//       //                       sx={{
//       //                         width: 4,
//       //                         height: 4,
//       //                         borderRadius: '50%',
//       //                         backgroundColor: '#1976d2',
//       //                         animation: 'pulse 1.4s ease-in-out infinite',
//       //                         animationDelay: `${dot * 0.16}s`,
//       //                         '@keyframes pulse': {
//       //                           '0%, 80%, 100%': {
//       //                             transform: 'scale(0.8)',
//       //                             opacity: 0.5,
//       //                           },
//       //                           '40%': {
//       //                             transform: 'scale(1)',
//       //                             opacity: 1,
//       //                           }
//       //                         }
//       //                       }}
//       //                     />
//       //                   ))}
//       //                 </Box>
//       //               )}
//       //             </Box>

//       //             {/* Date */}
//       //             {user.lastdateassign && (
//       //               <Typography
//       //                 variant="caption"
//       //                 sx={{
//       //                   color: '#666',
//       //                   fontSize: '11px'
//       //                 }}
//       //               >
//       //                 {moment(user.lastdateassign)
//       //                   .tz(moment.tz.guess())
//       //                   .format('DD/MM/YYYY h:mm A')}
//       //               </Typography>
//       //             )}
//       //           </Box>
//       //         );

//       case 'sales':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             {/* Sales Name with Loading */}
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                 {user?.assigntype === true ? (
//                   <Tooltip
//                     title={
//                       <Box sx={{ p: 0.5 }}>
//                         <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
//                           Team Information
//                         </Typography>
//                         <Box sx={{ mt: 0.5 }}>
//                           <Typography variant="body2">
//                             <strong>Team:</strong> {user.sales?.name || 'N/A'}
//                           </Typography>
//                           <Typography variant="body2">
//                             <strong>Team Leader:</strong>{' '}
//                             {user.sales?.teamleader?.name || user.teamleader || 'Not Assigned'}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     }
//                     arrow
//                     placement="top"
//                     componentsProps={{
//                       tooltip: {
//                         sx: {
//                           backgroundColor: 'background.paper',
//                           color: 'text.primary',
//                           border: '1px solid',
//                           borderColor: 'divider',
//                           maxWidth: 250,
//                         },
//                       },
//                     }}
//                   >
//                     <Box
//                       component="span"
//                       sx={{
//                         fontWeight: 'bold',
//                         color: 'red',
//                         cursor: 'help',
//                         borderBottom: '1px dotted',
//                         borderColor: 'grey.400',
//                         '&:hover': {
//                           borderColor: 'primary.main',
//                         },
//                       }}
//                     >
//                       Team: {user.sales?.teamleader?.name || 'N/A'}
//                     </Box>
//                   </Tooltip>
//                 ) : (
//                   <Tooltip
//                     title={`Team Leader: ${user.sales?.teamleader?.name || 'N/A'}`}
//                     arrow
//                     placement="top"
//                   >
//                     <span style={{ cursor: 'default' }}>{user.sales?.name || 'N/A'}</span>
//                   </Tooltip>
//                 )}
//               </Typography>

//               {/* Loading dots when assign is true */}
//               {user.assign === true && (
//                 <Tooltip title="Processing assignment...">
//                   <Box sx={{ display: 'flex', gap: 0.5, cursor: 'help' }}>
//                     {[1, 2, 3].map((dot) => (
//                       <Box
//                         key={dot}
//                         sx={{
//                           width: 4,
//                           height: 4,
//                           borderRadius: '50%',
//                           backgroundColor: '#1976d2',
//                           animation: 'pulse 1.4s ease-in-out infinite',
//                           animationDelay: `${dot * 0.16}s`,
//                           '@keyframes pulse': {
//                             '0%, 80%, 100%': {
//                               transform: 'scale(0.8)',
//                               opacity: 0.5,
//                             },
//                             '40%': {
//                               transform: 'scale(1)',
//                               opacity: 1,
//                             },
//                           },
//                         }}
//                       />
//                     ))}
//                   </Box>
//                 </Tooltip>
//               )}
//             </Box>

//             {/* Date */}
//             {user.lastdateassign && (
//               <Typography
//                 variant="caption"
//                 sx={{
//                   color: '#666',
//                   fontSize: '11px',
//                 }}
//               >
//                 {moment(user.lastdateassign).tz(moment.tz.guess()).format('DD/MM/YYYY h:mm A')}
//               </Typography>
//             )}
//           </Box>
//         );
//       // في دالة renderCell أضيف case جديدة:
//       // case 'lastComment':
//       //   return (
//       //     <TableCell
//       //       key={col.key}
//       //       sx={{
//       //         width: `${col.width}px`,
//       //         minWidth: `${col.width}px`,
//       //         maxWidth: `${col.width}px`,
//       //         verticalAlign: 'top',
//       //         textAlign: 'left',
//       //         padding: '4px 8px'
//       //       }}
//       //       onMouseEnter={() => handleCommentHover(user._id)}
//       //       onMouseLeave={handleCommentLeave}
//       //     >
//       //       <Tooltip
//       //         title={
//       //           hoveredLeadId === user._id ? (
//       //             loadingComments ? (
//       //               <div style={{
//       //                 padding: '10px 16px',
//       //                 background: 'rgba(97, 97, 97, 0.9)',
//       //                 color: '#fff',
//       //                 borderRadius: '8px',
//       //                 fontSize: '13px',
//       //                 minWidth: '120px',
//       //                 textAlign: 'center'
//       //               }}>
//       //                 Loading...
//       //               </div>
//       //             ) : !user.lastComment ? (
//       //               <div style={{
//       //                 padding: '10px 16px',
//       //                 background: 'rgba(97, 97, 97, 0.9)',
//       //                 color: '#fff',
//       //                 borderRadius: '8px',
//       //                 fontSize: '13px',
//       //                 minWidth: '120px',
//       //                 textAlign: 'center'
//       //               }}>
//       //                 No Comments
//       //               </div>
//       //             ) : (
//       //               <div style={{
//       //                 width: "450px",
//       //                 maxWidth: '90vw',
//       //                 padding: '20px',
//       //                 background: mode === 'dark' ? '#1e1e1e' : '#fff',
//       //                 borderRadius: '12px',
//       //                 color: mode === 'dark' ? '#fff' : '#333',
//       //                 fontSize: '14px',
//       //                 lineHeight: '1.5',
//       //                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                 boxShadow: '0 8px 30px rgba(0,0,0,0.12)'
//       //               }}>
//       //                 {/* Header - Sales Info + Stage */}
//       //                 <div style={{
//       //                   display: 'flex',
//       //                   justifyContent: 'space-between',
//       //                   alignItems: 'flex-start',
//       //                   marginBottom: '16px',
//       //                   paddingBottom: '12px',
//       //                   borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0'
//       //                 }}>
//       //                   {/* Sales Info - Avatar with first 2 letters */}
//       //                   <div style={{
//       //                     display: 'flex',
//       //                     alignItems: 'center',
//       //                     gap: '12px'
//       //                   }}>
//       //                     <Avatar
//       //                       sx={{
//       //                         width: 40,
//       //                         height: 40,
//       //                         bgcolor: '#102dff',
//       //                         fontSize: '14px',
//       //                         fontWeight: 'bold'
//       //                       }}
//       //                     >
//       //                       {user.lastComment.sales?.name ?
//       //                         user.lastComment.sales.name.substring(0, 2).toUpperCase()
//       //                         : '?'
//       //                       }
//       //                     </Avatar>
//       //                     <div>
//       //                       <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '2px' }}>
//       //                         {user.lastComment.sales?.name || "Unknown Sales"}
//       //                       </div>
//       //                       <div style={{ fontSize: '13px', color: mode === 'dark' ? '#ccc' : '#666' }}>
//       //                         {user.lastComment.sales?.role || "Sales"}
//       //                       </div>
//       //                     </div>
//       //                   </div>

//       //                   {/* Stage on the right - under sales name */}
//       //                   {(user.lastComment.stage || user.stage) && (
//       //                     <div style={{
//       //                       textAlign: 'right'
//       //                     }}>

//       //                       <div style={{
//       //                         fontWeight: '600',
//       //                         color: mode === 'dark' ? '#90caf9' : '#102dff',
//       //                         fontSize: '14px'
//       //                       }}>
//       //                         {/* نستخدم الـ stage من lastComment أو من الـ user نفسه */}
//       //                        Stage: {user.lastComment.stage?.name|| user.stage?.name|| "Undefined"}
//       //                       </div>
//       //                     {(user.lastComment.stageDate) && (
//       //   <div style={{
//       //     fontSize: '11px',
//       //     color: mode === 'dark' ? '#999' : '#888',
//       //     marginTop: '2px'
//       //   }}>
//       // <span>
//       //   SD : | {
//       //     new Date(user.lastComment.stageDate).toLocaleString('en-US', {
//       //       year: 'numeric',
//       //       month: '2-digit',
//       //       day: '2-digit',
//       //       hour: '2-digit',
//       //       minute: '2-digit',
//       //       hour12: true
//       //     })
//       //   }
//       // </span>
//       //   </div>
//       // )}
//       //                     </div>
//       //                   )}
//       //                 </div>

//       //                 {/* Comment Date - Only if exists - 12 hour format */}
//       //                 {user.lastComment.firstcomment?.date && (
//       //                   <div style={{
//       //                     display: 'flex',
//       //                     justifyContent: 'center',
//       //                     alignItems: 'center',
//       //                     gap: '6px',
//       //                     fontSize: '12px',
//       //                     color: mode === 'dark' ? '#ccc' : '#666',
//       //                     marginBottom: '16px',
//       //                     padding: '6px 12px',
//       //                     background: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//       //                     borderRadius: '6px'
//       //                   }}>
//       //                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                       <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//       //                       <line x1="16" y1="2" x2="16" y2="6"></line>
//       //                       <line x1="8" y1="2" x2="8" y2="6"></line>
//       //                       <line x1="3" y1="10" x2="21" y2="10"></line>
//       //                     </svg>
//       //                     {new Date(user.lastComment.firstcomment.date).toLocaleDateString() + ' • ' +
//       //                      new Date(user.lastComment.firstcomment.date).toLocaleTimeString('en-US', {
//       //                        hour: '2-digit',
//       //                        minute: '2-digit',
//       //                        hour12: true
//       //                      })}
//       //                   </div>
//       //                 )}

//       //                 {/* First Comment (Comment) */}
//       //                 {user.lastComment.firstcomment?.text && user.lastComment.firstcomment.text !== '-' && (
//       //                   <div style={{ marginBottom: '16px' }}>
//       //                     <div style={{
//       //                       fontWeight: '600',
//       //                       color: mode === 'dark' ? '#90caf9' : '#102dff',
//       //                       fontSize: '14px',
//       //                       marginBottom: '8px',
//       //                       display: 'flex',
//       //                       alignItems: 'center',
//       //                       gap: '6px'
//       //                     }}>
//       //                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                         <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//       //                       </svg>
//       //                       Comment
//       //                     </div>
//       //                     <div style={{
//       //                       padding: '12px 16px',
//       //                       borderRadius: '8px',
//       //                       fontSize: '14px',
//       //                       lineHeight: '1.5',
//       //                       border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                       background: 'transparent'
//       //                     }}>
//       //                       {user.lastComment.firstcomment.text}
//       //                     </div>
//       //                   </div>
//       //                 )}

//       //                 {/* Second Comment (Action Plan) */}
//       //                 {user.lastComment.secondcomment?.text && user.lastComment.secondcomment.text !== '-' && (
//       //                   <div style={{ marginBottom: '12px' }}>
//       //                     <div style={{
//       //                       fontWeight: '600',
//       //                       color: mode === 'dark' ? '#4caf50' : '#2e7d32',
//       //                       fontSize: '14px',
//       //                       marginBottom: '8px',
//       //                       display: 'flex',
//       //                       alignItems: 'center',
//       //                       gap: '6px'
//       //                     }}>
//       //                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                         <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//       //                         <polyline points="14,2 14,8 20,8"></polyline>
//       //                         <line x1="16" y1="13" x2="8" y2="13"></line>
//       //                         <line x1="16" y1="17" x2="8" y2="17"></line>
//       //                         <polyline points="10,9 9,9 8,9"></polyline>
//       //                       </svg>
//       //                       Action Plan
//       //                     </div>
//       //                     <div style={{
//       //                       padding: '12px 16px',
//       //                       borderRadius: '8px',
//       //                       fontSize: '14px',
//       //                       lineHeight: '1.5',
//       //                       border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                       background: 'transparent'
//       //                     }}>
//       //                       {user.lastComment.secondcomment.text}
//       //                     </div>
//       //                   </div>
//       //                 )}

//       //                 {/* Last Updated */}
//       //                 <div style={{
//       //                   fontSize: '11px',
//       //                   color: mode === 'dark' ? '#999' : '#888',
//       //                   textAlign: 'center',
//       //                   marginTop: '16px',
//       //                   paddingTop: '12px',
//       //                   borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                   display: 'flex',
//       //                   alignItems: 'center',
//       //                   justifyContent: 'center',
//       //                   gap: '6px'
//       //                 }}>
//       //                   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                     <circle cx="12" cy="12" r="10"></circle>
//       //                     <polyline points="12,6 12,12 16,14"></polyline>
//       //                   </svg>
//       //                   Last updated: {user.lastComment.actionUpdatedAt ?
//       //                     new Date(user.lastComment.actionUpdatedAt).toLocaleDateString('en-US', {
//       //                       year: 'numeric',
//       //                       month: '2-digit',
//       //                       day: '2-digit'
//       //                     })
//       //                     : 'Unknown'
//       //                   }
//       //                 </div>
//       //               </div>
//       //             )
//       //           ) : null
//       //         }
//       //         arrow
//       //         placement="left-start"
//       //         componentsProps={{
//       //           tooltip: {
//       //             sx: {
//       //               backgroundColor: 'transparent',
//       //               padding: 0,
//       //               m: 0,
//       //               boxShadow: 'none',
//       //               border: 'none',
//       //               overflow: 'visible',
//       //               maxWidth: 'none'
//       //             }
//       //           }
//       //         }}
//       //       >
//       //         <IconButton
//       //           size="small"
//       //           sx={{
//       //             color: user.lastComment ?
//       //               (mode === 'dark' ? '#90caf9' : '#102dff') :
//       //               (mode === 'dark' ? '#666' : '#ccc'),
//       //             '&:hover': {
//       //               backgroundColor: mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//       //             }
//       //           }}
//       //         >
//       //           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //             <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//       //           </svg>
//       //           {user.lastComment && (
//       //             <Box
//       //               sx={{
//       //                 position: 'absolute',
//       //                 top: 4,
//       //                 right: 4,
//       //                 width: 6,
//       //                 height: 6,
//       //                 borderRadius: '50%',
//       //                 backgroundColor: mode === 'dark' ? '#4caf50' : '#2e7d32',
//       //               }}
//       //             />
//       //           )}
//       //         </IconButton>
//       //       </Tooltip>
//       //     </TableCell>
//       //   );
//       case 'lastComment':
//         return (
//           <Box
//             onMouseEnter={() => handleCommentHover(user._id)}
//             onMouseLeave={handleCommentLeave}
//             sx={{
//               width: '100%',
//               height: '100%',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               cursor: 'pointer',
//             }}
//           >
//             <Tooltip
//               title={
//                 <div
//                   style={{
//                     width: '450px',
//                     maxWidth: '90vw',
//                     padding: '20px',
//                     background: mode === 'dark' ? '#1e1e1e' : '#fff',
//                     borderRadius: '12px',
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     fontSize: '14px',
//                     lineHeight: '1.5',
//                     border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                     boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
//                   }}
//                 >
//                   {/* حالة التحميل */}
//                   {loadingComments ? (
//                     <Box sx={{ textAlign: 'center', py: 3 }}>
//                       <CircularProgress
//                         size={24}
//                         sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                       />
//                       <Typography sx={{ mt: 2, color: mode === 'dark' ? '#ccc' : '#666' }}>
//                         Loading comments...
//                       </Typography>
//                     </Box>
//                   ) : !user.lastComment ? (
//                     <Box sx={{ textAlign: 'center', py: 3 }}>
//                       <svg
//                         width="48"
//                         height="48"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke={mode === 'dark' ? '#666' : '#999'}
//                       >
//                         <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                       </svg>
//                       <Typography
//                         sx={{ mt: 2, color: mode === 'dark' ? '#ccc' : '#666', fontWeight: '500' }}
//                       >
//                         No Comments Yet
//                       </Typography>
//                       <Typography
//                         variant="caption"
//                         sx={{ color: mode === 'dark' ? '#999' : '#888' }}
//                       >
//                         No comments have been added to this lead
//                       </Typography>
//                     </Box>
//                   ) : (
//                     <>
//                       {/* Header - Sales Info + Stage */}
//                       <div
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'flex-start',
//                           marginBottom: '16px',
//                           paddingBottom: '12px',
//                           borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                         }}
//                       >
//                         {/* Sales Info - Avatar with first 2 letters */}
//                         <div
//                           style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '12px',
//                           }}
//                         >
//                           <Avatar
//                             sx={{
//                               width: 40,
//                               height: 40,
//                               bgcolor: '#102dff',
//                               fontSize: '14px',
//                               fontWeight: 'bold',
//                             }}
//                           >
//                             {user.lastComment.sales?.name
//                               ? user.lastComment.sales.name.substring(0, 2).toUpperCase()
//                               : '?'}
//                           </Avatar>
//                           <div>
//                             <div
//                               style={{ fontWeight: '600', fontSize: '16px', marginBottom: '2px' }}
//                             >
//                               {user.lastComment.sales?.name || 'Unknown Sales'}
//                             </div>
//                             <div
//                               style={{ fontSize: '13px', color: mode === 'dark' ? '#ccc' : '#666' }}
//                             >
//                               {user.lastComment.sales?.role || 'Sales'}
//                             </div>
//                           </div>
//                         </div>

//                         {/* Stage on the right - under sales name */}
//                         {(user.lastComment.stage || user.stage) && (
//                           <div
//                             style={{
//                               textAlign: 'right',
//                             }}
//                           >
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#90caf9' : '#102dff',
//                                 fontSize: '14px',
//                               }}
//                             >
//                               Stage:{' '}
//                               {user.lastComment.stage?.name || user.stage?.name || 'Undefined'}
//                             </div>
//                             {user.lastComment.stageDate && (
//                               <div
//                                 style={{
//                                   fontSize: '11px',
//                                   color: mode === 'dark' ? '#999' : '#888',
//                                   marginTop: '2px',
//                                 }}
//                               >
//                                 <span>
//                                   SD : |{' '}
//                                   {new Date(user.lastComment.stageDate).toLocaleString('en-US', {
//                                     year: 'numeric',
//                                     month: '2-digit',
//                                     day: '2-digit',
//                                     hour: '2-digit',
//                                     minute: '2-digit',
//                                     hour12: true,
//                                   })}
//                                 </span>
//                               </div>
//                             )}
//                           </div>
//                         )}
//                       </div>

//                       {/* Comment Date - Only if exists - 12 hour format */}
//                       {user.lastComment.firstcomment?.date && (
//                         <div
//                           style={{
//                             display: 'flex',
//                             justifyContent: 'center',
//                             alignItems: 'center',
//                             gap: '6px',
//                             fontSize: '12px',
//                             color: mode === 'dark' ? '#ccc' : '#666',
//                             marginBottom: '16px',
//                             padding: '6px 12px',
//                             background:
//                               mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                             borderRadius: '6px',
//                           }}
//                         >
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                           >
//                             <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//                             <line x1="16" y1="2" x2="16" y2="6"></line>
//                             <line x1="8" y1="2" x2="8" y2="6"></line>
//                             <line x1="3" y1="10" x2="21" y2="10"></line>
//                           </svg>
//                           {new Date(user.lastComment.firstcomment.date).toLocaleDateString() +
//                             ' • ' +
//                             new Date(user.lastComment.firstcomment.date).toLocaleTimeString(
//                               'en-US',
//                               {
//                                 hour: '2-digit',
//                                 minute: '2-digit',
//                                 hour12: true,
//                               },
//                             )}
//                         </div>
//                       )}

//                       {/* First Comment (Comment) */}
//                       {user.lastComment.firstcomment?.text &&
//                         user.lastComment.firstcomment.text !== '-' && (
//                           <div style={{ marginBottom: '16px' }}>
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#90caf9' : '#102dff',
//                                 fontSize: '14px',
//                                 marginBottom: '8px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                               }}
//                             >
//                               <svg
//                                 width="16"
//                                 height="16"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                               >
//                                 <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                               </svg>
//                               Comment
//                             </div>
//                             <div
//                               style={{
//                                 padding: '12px 16px',
//                                 borderRadius: '8px',
//                                 fontSize: '14px',
//                                 lineHeight: '1.5',
//                                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                                 background: 'transparent',
//                               }}
//                             >
//                               {user.lastComment.firstcomment.text}
//                             </div>
//                           </div>
//                         )}

//                       {/* Second Comment (Action Plan) */}
//                       {user.lastComment.secondcomment?.text &&
//                         user.lastComment.secondcomment.text !== '-' && (
//                           <div style={{ marginBottom: '12px' }}>
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#4caf50' : '#2e7d32',
//                                 fontSize: '14px',
//                                 marginBottom: '8px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                               }}
//                             >
//                               <svg
//                                 width="16"
//                                 height="16"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                               >
//                                 <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//                                 <polyline points="14,2 14,8 20,8"></polyline>
//                                 <line x1="16" y1="13" x2="8" y2="13"></line>
//                                 <line x1="16" y1="17" x2="8" y2="17"></line>
//                                 <polyline points="10,9 9,9 8,9"></polyline>
//                               </svg>
//                               Action Plan
//                             </div>
//                             <div
//                               style={{
//                                 padding: '12px 16px',
//                                 borderRadius: '8px',
//                                 fontSize: '14px',
//                                 lineHeight: '1.5',
//                                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                                 background: 'transparent',
//                               }}
//                             >
//                               {user.lastComment.secondcomment.text}
//                             </div>
//                           </div>
//                         )}

//                       {/* Last Updated */}
//                       <div
//                         style={{
//                           fontSize: '11px',
//                           color: mode === 'dark' ? '#999' : '#888',
//                           textAlign: 'center',
//                           marginTop: '16px',
//                           paddingTop: '12px',
//                           borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           gap: '6px',
//                         }}
//                       >
//                         <svg
//                           width="12"
//                           height="12"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="currentColor"
//                         >
//                           <circle cx="12" cy="12" r="10"></circle>
//                           <polyline points="12,6 12,12 16,14"></polyline>
//                         </svg>
//                         Last updated:{' '}
//                         {user.lastComment.actionUpdatedAt
//                           ? new Date(user.lastComment.actionUpdatedAt).toLocaleDateString('en-US', {
//                               year: 'numeric',
//                               month: '2-digit',
//                               day: '2-digit',
//                             })
//                           : 'Unknown'}
//                       </div>
//                     </>
//                   )}
//                 </div>
//               }
//               arrow
//               placement="left-start"
//               componentsProps={{
//                 tooltip: {
//                   sx: {
//                     backgroundColor: 'transparent',
//                     padding: 0,
//                     m: 0,
//                     boxShadow: 'none',
//                     border: 'none',
//                     overflow: 'visible',
//                     maxWidth: 'none',
//                   },
//                 },
//               }}
//             >
//               <IconButton
//                 size="small"
//                 sx={{
//                   color: user.lastComment
//                     ? mode === 'dark'
//                       ? '#90caf9'
//                       : '#102dff'
//                     : mode === 'dark'
//                       ? '#666'
//                       : '#ccc',
//                   '&:hover': {
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//                   },
//                 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                   <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                 </svg>
//                 {user.lastComment && (
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: 4,
//                       right: 4,
//                       width: 6,
//                       height: 6,
//                       borderRadius: '50%',
//                       backgroundColor: mode === 'dark' ? '#4caf50' : '#2e7d32',
//                     }}
//                   />
//                 )}
//               </IconButton>
//             </Tooltip>
//           </Box>
//         );

//       case 'stage':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
//             {user.stage?.name && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 {user.stage.name === 'Done Deal' ? (
//                   <span style={{ fontSize: '18px' }}>🎉</span>
//                 ) : user.stage.name === 'Pending' ? (
//                   <SevereColdIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : user.stage.name === 'Fresh' ? (
//                   <CheckIcon sx={{ fontSize: '18px', color: '#4caf50' }} />
//                 ) : user.stage.name === 'Not Interested' ? (
//                   <Box
//                     sx={{
//                       fontSize: '18px',
//                       color: '#333',
//                       borderRadius: '50%',
//                       width: '20px',
//                       height: '20px',
//                       backgroundColor: '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     -
//                   </Box>
//                 ) : user.stage.name === 'EOI' ? (
//                   <EditNoteIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : user.stage.name === 'Reservation' ? (
//                   <AssignmentTurnedInIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : user.stage.name === 'Transfer' ? (
//                   <TransferWithinAStationIcon sx={{ color: 'red', fontSize: '18px' }} />
//                 ) : (
//                   <Box
//                     sx={{
//                       backgroundColor: moment(user.stagedateupdated).isBefore(moment())
//                         ? '#CC5500'
//                         : 'royalblue',
//                       borderRadius: '50%',
//                       width: '20px',
//                       height: '20px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       color: '#fff',
//                     }}
//                   ></Box>
//                 )}
//                 <Typography variant="body2" sx={{ color: mode === 'dark' ? '#fff' : '#666' }}>
//                   {user?.stage?.name}
//                 </Typography>
//               </Box>
//             )}
//             {user.stagedateupdated && (
//               <Typography variant="caption" sx={{ color: '#666', fontSize: '11px' }}>
//                 {moment(user.stagedateupdated).format('DD/MM/YYYY h:mm A')}
//               </Typography>
//             )}
//           </Box>
//         );

//       case 'status':
//         return <StatusChip active={user.leadisactive} />;

//       case 'Creation_date':
//         return (
//           <Box>
//             <Typography variant="body2">{new Date(user.createdAt).toLocaleDateString()}</Typography>
//             <Typography variant="caption" display="block" color="text.secondary">
//               {new Date(user.createdAt).toLocaleTimeString([], {
//                 hour: '2-digit',
//                 minute: '2-digit',
//               })}
//             </Typography>
//           </Box>
//         );

//       case 'AddedBy':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Avatar
//                 sx={{
//                   width: 32,
//                   height: 32,
//                   fontSize: '0.8rem',
//                   bgcolor: mode === 'dark' ? 'secondary.main' : 'primary.main',
//                 }}
//               >
//                 {getInitials(user.addby?.name)}
//               </Avatar>
//               <Box>
//                 <Typography variant="body2" fontWeight="medium">
//                   {user.addby?.name || 'N/A'}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   {user.addby?.role || 'No Role'}
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>
//         );

//       case 'actions':
//         return <ClientTable2 user={user} allusers={get_all_Leads} />;

//       default:
//         return <Typography variant="body2">{user[col.key] || 'N/A'}</Typography>;
//     }
//   };

//   // state للـ Quick Filter Modal
//   const [quickFilterOpen, setQuickFilterOpen] = useState(false);

//   // دوال فتح وإغلاق الـ Modal
//   const handleQuickFilterOpen = () => setQuickFilterOpen(true);
//   const handleQuickFilterClose = () => setQuickFilterOpen(false);

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         minHeight: '100vh',
//         marginTop: isSmallScreen ? '120px' : isMediumScreen ? '30px' : '50px',
//         marginLeft: isSmallScreen ? '10px' : isMediumScreen ? '30px' : '50px',
//         padding: isSmallScreen ? '10px' : '20px',
//         backgroundColor: mode === 'dark' ? '#121212' : '#fff',
//         position: 'relative',
//       }}
//       className="startPage"
//     >
//       {/* Modals */}
//       {/* {selectedLead && (
//         <ShowClientsActions 
//           user={selectedLead} 
//           leadid={selectedLead._id}
//           onClose={() => setSelectedLead(null)}
//         />
//       )} */}

//       {selectedLead && (
//         <ShowClientsActionsAdvanced
//           user={selectedLead}
//           leadid={selectedLead._id}
//           onClose={() => setSelectedLead(null)}
//         />
//       )}

//       <LeadDuplicationModal
//         open={duplicationModal.open}
//         onClose={() => setDuplicationModal({ open: false, leadId: null, leadName: '' })}
//         leadId={duplicationModal.leadId}
//         leadName={duplicationModal.leadName}
//       />

//       {/* Quick Filter Modal */}
//       <QuickFilterModal
//         open={quickFilterOpen}
//         onClose={handleQuickFilterClose}
//         onApplyFilters={handleApplyFilters}
//       />

// {/* وحط الـ Dialog بعد الأزرار */}
// <Admin_Report_Model_For_Requested_Data
//   open={adminReportDialogOpen}
//   onClose={() => setAdminReportDialogOpen(false)}
// />

//       {/* Delete All Selected Leads Modal */}
//       <Modal
//         style={{ zIndex: '20000' }}
//         show={showmoredelete}
//         onHide={handleClosemoredelete}
//         centered
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             color: mode === 'dark' ? '#90caf9' : '#1976d2',
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f8f9fa',
//             borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//             padding: '20px 24px',
//           }}
//         >
//           <Modal.Title
//             style={{
//               fontWeight: '600',
//               fontSize: '1.25rem',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '10px',
//             }}
//           >
//             <DeleteOutlineIcon style={{ fontSize: '28px', color: '#d32f2f' }} />
//             Delete Selected Leads
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body
//           style={{
//             color: mode === 'dark' ? '#e0e0e0' : '#424242',
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//             padding: '24px',
//           }}
//         >
//           <div style={{ textAlign: 'center', marginBottom: '20px' }}>
//             <h5
//               style={{
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 fontWeight: '500',
//                 marginBottom: '16px',
//               }}
//             >
//               Confirm Deletion
//             </h5>
//             <p style={{ fontSize: '16px', marginBottom: '20px' }}>
//               Are you sure you want to delete{' '}
//               <strong style={{ color: '#d32f2f' }}>{selectedLeads.length}</strong> selected lead(s)?
//             </p>

//             <div
//               style={{
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.05)',
//                 padding: '12px 16px',
//                 borderRadius: '8px',
//                 border: '1px solid #d32f2f',
//                 marginBottom: '16px',
//               }}
//             >
//               <span
//                 style={{
//                   color: '#d32f2f',
//                   fontWeight: '500',
//                   fontSize: '14px',
//                 }}
//               >
//                 ⚠️ This action cannot be undone
//               </span>
//             </div>
//           </div>

//           <hr
//             style={{
//               border: 'none',
//               height: '1px',
//               backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0',
//               margin: '20px 0',
//             }}
//           />

//           <div
//             className="d-flex justify-content-between align-items-center"
//             style={{
//               color: mode === 'dark' ? '#e0e0e0' : '#424242',
//               backgroundColor: 'transparent',
//             }}
//           >
//             <Button
//               style={{
//                 background: 'transparent',
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 border: '2px solid',
//                 borderColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 borderRadius: '8px',
//                 padding: '8px 20px',
//                 fontWeight: '500',
//                 transition: 'all 0.3s ease',
//               }}
//               onMouseOver={(e) => {
//                 e.target.style.background =
//                   mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(25, 118, 210, 0.1)';
//               }}
//               onMouseOut={(e) => {
//                 e.target.style.background = 'transparent';
//               }}
//               onClick={handleClosemoredelete}
//             >
//               <CloseIcon style={{ marginRight: '8px', fontSize: '18px' }} />
//               Cancel
//             </Button>

//             <Button
//               style={{
//                 background: '#102dff',
//                 color: '#fff',
//                 border: '2px solid #102dff',
//                 borderRadius: '8px',
//                 padding: '8px 24px',
//                 fontWeight: '500',
//                 transition: 'all 0.3s ease',
//                 boxShadow: '0 2px 8px rgba(31, 7, 173, 0.3)',
//               }}
//               onMouseOver={(e) => {
//                 e.target.style.background = '#1f34d7ff';
//                 e.target.style.boxShadow = '0 4px 12px rgba(31, 7, 173, 0.3)';
//               }}
//               onMouseOut={(e) => {
//                 e.target.style.background = '#102dff';
//                 e.target.style.boxShadow = '0 2px 8px rgba(31, 7, 173, 0.3)';
//               }}
//               type="submit"
//               onClick={handledeleteallselectedleads}
//             >
//               <DeleteOutlineIcon style={{ marginRight: '8px', fontSize: '18px' }} />
//               Delete {selectedLeads.length} Lead(s)
//             </Button>
//           </div>

//           {message && (
//             <div className="d-flex justify-content-center flex-wrap" style={{ marginTop: '16px' }}>
//               <p
//                 style={{
//                   color: '#d32f2f',
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.05)',
//                   padding: '12px 16px',
//                   borderRadius: '8px',
//                   border: '1px solid #d32f2f',
//                   fontWeight: '500',
//                   textAlign: 'center',
//                   width: '100%',
//                   margin: 0,
//                 }}
//               >
//                 {message}
//               </p>
//             </div>
//           )}
//         </Modal.Body>
//       </Modal>

//       {/* <Modal show={openimport2} onHide={handleCloseimport2} centered>
//   <Modal.Header closeButton>
//     <Modal.Title>Import Leads</Modal.Title>
//   </Modal.Header>
//   <Modal.Body>
//     <Form.Group controlId="formFile" className="mb-3">
//       <Form.Label style={{ textDecoration: 'underline', cursor: 'pointer', color: '#007bff' }}>
//         Choose Excel File From Your PC
//       </Form.Label>
// <Form.Control type="file" accept=".xlsx,.xls" onChange={handleFileSelect} />
//     </Form.Group>

//     {fileimport2 && (
//       <p className="text-muted">📎 Selected File: <strong>{fileimport2.name}</strong></p>
//     )}

//     {previewData.length > 0 && (
//       <div style={{ maxHeight: 150, overflowY: 'auto', border: '1px solid #ccc', padding: 10 }}>
//         <strong>Preview First Two Record:</strong>
//         <pre>{JSON.stringify(previewData.slice(0, 2), null, 2)}</pre>
//       </div>
//     )}

//     <Button
//       variant="primary"
//       onClick={onUploadimportleads2}
//       disabled={loadingimprt2 || !fileimport2}
//       className="w-100 mt-3"
//     >
//       {loadingimprt2 ? <Spinner animation="border" size="sm" /> : 'Upload Excel File'}
//     </Button>

//     {resultimport2 && (
//       <Alert variant="success" className="mt-3">
//         <pre>{JSON.stringify(resultimport2, null, 2)}</pre>
//       </Alert>
//     )}

//     {errorimport2 && (
//       <Alert variant="danger" className="mt-3">
//         <pre>{JSON.stringify(errorimport2, null, 2)}</pre>
//       </Alert>
//     )}
//   </Modal.Body>
//   <Modal.Footer>
//     <Button variant="secondary" onClick={handleCloseimport2}>
//       Close
//     </Button>
//   </Modal.Footer>
// </Modal> */}

//       <Modal show={openimport2} onHide={handleCloseimport2} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Import Leads</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* ✅ قسم معاينة قالب Excel */}
//           <div className="mb-4 p-3 border rounded bg-light">
//             <div className="d-flex justify-content-between align-items-center mb-2">
//               <strong className="text-primary">📋 Excel Template Preview</strong>
//               <Button
//                 variant="outline-primary"
//                 size="sm"
//                 onClick={() => {
//                   downloadExcelTemplate();
//                 }}
//               >
//                 Download Template
//               </Button>
//             </div>

//             <small className="text-muted d-block mb-2">
//               Your Excel file should have these columns (first row as headers):
//             </small>

//             <div
//               style={{
//                 maxHeight: 250,
//                 overflowY: 'auto',
//                 backgroundColor: '#f8f9fa',
//                 border: '1px solid #dee2e6',
//                 borderRadius: '4px',
//                 padding: '10px',
//                 fontFamily: 'monospace',
//                 fontSize: '11px',
//               }}
//             >
//               <table className="table table-sm table-bordered mb-0">
//                 <thead className="table-dark">
//                   <tr>
//                     <th>name</th>
//                     <th>phone</th>
//                     <th>email</th>
//                     <th>project_name</th>
//                     <th>sales_name</th>
//                     <th>chanel_name</th>
//                     <th>communication_way</th>
//                     <th>stage_name</th>
//                     <th>campaign_name</th>
//                     <th>addby_name</th>
//                     <th>updatedby_name</th>
//                     <th>budget</th>
//                     <th>leedtype</th>
//                     <th>stagedateupdated</th>
//                     <th>dayonly</th>
//                     <th>last_stage_date_updated</th>
//                     <th>creation_date</th>
//                     <th>Last_Date_Assigned</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>Ahmed Hassan</td>
//                     <td>+971501234567</td>
//                     <td>ahmed@email.com</td>
//                     <td>Dubai Hills</td>
//                     <td>Mohamed Ali</td>
//                     <td>008 | A</td>
//                     <td>Call</td>
//                     <td>Pending</td>
//                     <td>Summer Campaign</td>
//                     <td>Smoth Van</td>
//                     <td>Smoth Van</td>
//                     <td>1500000</td>
//                     <td>Cold</td>
//                     <td>2024-03-15</td>
//                     <td>2024-03-15</td>
//                     <td>2024-03-15</td>
//                     <td>2024-01-10</td>
//                     <td>2024-03-01</td>
//                   </tr>
//                   <tr>
//                     <td>Sarah Johnson</td>
//                     <td>+971502345678</td>
//                     <td>sarah@email.com</td>
//                     <td>Palm Jumeirah</td>
//                     <td>Fatima Ahmed</td>
//                     <td>008 | A</td>
//                     <td>Phone Call</td>
//                     <td>Fresh</td>
//                     <td>Luxury Homes</td>
//                     <td>johan De</td>
//                     <td>johan De</td>
//                     <td>2800000</td>
//                     <td>Fresh</td>
//                     <td>2024-03-10</td>
//                     <td>2024-03-10</td>
//                     <td>2024-03-10</td>
//                     <td>2024-01-25</td>
//                     <td>2024-02-15</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>

//             <div className="mt-2">
//               <small className="text-muted">
//                 <strong>📌 Important Notes:</strong>
//                 <ul className="mb-0 ps-3">
//                   <li>
//                     Keep the <strong>exact column names</strong> as shown above (case-sensitive)
//                   </li>
//                   <li>
//                     <strong>project_name, sales_name, chanel_name, stage_name</strong> must match
//                     existing names in the system
//                   </li>
//                   <li>
//                     <strong>Dates format:</strong> YYYY-MM-DD (e.g., 2024-03-15)
//                   </li>
//                   <li>
//                     <strong>Phone numbers:</strong> Include country code (e.g., +971501234567)
//                   </li>
//                 </ul>
//               </small>
//             </div>
//           </div>

//           <Form.Group controlId="formFile" className="mb-3">
//             <Form.Label
//               style={{ textDecoration: 'underline', cursor: 'pointer', color: '#007bff' }}
//             >
//               📁 Choose Excel File From Your PC
//             </Form.Label>
//             <Form.Control type="file" accept=".xlsx,.xls" onChange={handleFileSelect} />
//             <Form.Text className="text-muted">
//               Supported formats: .xlsx, .xls (Max size: 10MB)
//             </Form.Text>
//           </Form.Group>

//           {fileimport2 && (
//             <div className="alert alert-info d-flex align-items-center">
//               <div className="me-2">📎</div>
//               <div>
//                 <strong>Selected File:</strong> {fileimport2.name}
//                 <small className="d-block text-muted">
//                   Size: {(fileimport2.size / 1024).toFixed(2)} KB | Type: {fileimport2.type} | Last
//                   Modified: {new Date(fileimport2.lastModified).toLocaleDateString()}
//                 </small>
//               </div>
//             </div>
//           )}

//           {previewData.length > 0 && (
//             <div className="mt-3">
//               <strong className="text-success">✅ Data Preview (First 2 rows):</strong>
//               <div
//                 style={{
//                   maxHeight: 200,
//                   overflowY: 'auto',
//                   border: '1px solid #28a745',
//                   padding: 10,
//                   backgroundColor: '#f8fff9',
//                   borderRadius: '4px',
//                 }}
//               >
//                 <table className="table table-sm table-striped mb-0">
//                   <thead>
//                     <tr>
//                       {Object.keys(previewData[0] || {}).map((key) => (
//                         <th key={key} className="text-nowrap">
//                           {key}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {previewData.slice(0, 2).map((row, index) => (
//                       <tr key={index}>
//                         {Object.values(row).map((value, i) => (
//                           <td key={i} className="text-nowrap">
//                             {value === null || value === undefined || value === '' ? (
//                               <span className="text-muted fst-italic">empty</span>
//                             ) : (
//                               String(value)
//                             )}
//                           </td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//               <small className="text-muted">
//                 Showing {Math.min(previewData.length, 2)} of {previewData.length} rows
//                 {previewData.length > 2 && ' - Full data will be imported'}
//               </small>
//             </div>
//           )}

//           <Button
//             variant="primary"
//             onClick={onUploadimportleads2}
//             disabled={loadingimprt2 || !fileimport2}
//             className="w-100 mt-3 py-2"
//           >
//             {loadingimprt2 ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" />
//                 Uploading & Processing...
//               </>
//             ) : (
//               '📤 Upload Excel File'
//             )}
//           </Button>

//           {resultimport2 && (
//             <Alert variant="success" className="mt-3">
//               <div className="d-flex align-items-center">
//                 <div className="me-2">✅</div>
//                 <div>
//                   <strong>Import Completed Successfully!</strong>
//                   <div className="mt-2">
//                     <div className="mb-1">
//                       <span className="badge bg-success me-2">
//                         Imported: {resultimport2.importedCount || 0}
//                       </span>
//                       <span className="badge bg-warning me-2">
//                         Skipped: {resultimport2.skippedCount || 0}
//                       </span>
//                       <span className="badge bg-danger">
//                         Errors: {resultimport2.errors?.length || 0}
//                       </span>
//                     </div>

//                     {resultimport2.errors && resultimport2.errors.length > 0 && (
//                       <div className="mt-2">
//                         <strong>Error Details:</strong>
//                         <div
//                           className="mt-1 small"
//                           style={{ maxHeight: '100px', overflowY: 'auto' }}
//                         >
//                           {resultimport2.errors.slice(0, 5).map((error, i) => (
//                             <div
//                               key={i}
//                               className="text-danger border-start border-3 border-danger ps-2 mb-1"
//                             >
//                               <strong>Row {error.row}:</strong> {error.message}
//                             </div>
//                           ))}
//                           {resultimport2.errors.length > 5 && (
//                             <div className="text-muted">
//                               ... and {resultimport2.errors.length - 5} more errors
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}

//                     {resultimport2.message && (
//                       <div className="mt-2 text-success">
//                         <small>{resultimport2.message}</small>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </Alert>
//           )}

//           {errorimport2 && (
//             <Alert variant="danger" className="mt-3">
//               <div className="d-flex align-items-center">
//                 <div className="me-2">❌</div>
//                 <div>
//                   <strong>Import Failed!</strong>
//                   <div className="mt-1">
//                     {typeof errorimport2 === 'string'
//                       ? errorimport2
//                       : errorimport2.message || JSON.stringify(errorimport2, null, 2)}
//                   </div>
//                 </div>
//               </div>
//             </Alert>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseimport2}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Header Section */}
//       {/* Header Section */}
//       {/* Header Section */}
//       <Box
//         className="my-3"
//         sx={{
//           mb: 4,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           flexWrap: 'wrap',
//           gap: 2,
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             sx={{
//               fontWeight: 'bold',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//             }}
//           >
//             Data Center Management
//           </Typography>
//           <Typography
//             variant="body1"
//             sx={{
//               color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//             }}
//           >
//             Manage and track all leads Data Center in the system
//           </Typography>
//         </Box>

//         {/* Buttons Container */}
//         <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//           {/* Create New Lead Button - بنفس ستايل Table Settings */}
//           <Link to={`/addclient`} style={{ textDecoration: 'none' }}>
//             <Button
//               variant="outlined"
//               startIcon={<AddCircleOutlineOutlinedIcon />}
//               sx={{
//                 minWidth: 'auto',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                 color: mode === 'dark' ? '#fff' : '#1976d2',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                   borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//                 },
//               }}
//             >
//               Create New Lead
//             </Button>
//           </Link>

//           {/* <Button
//     variant="outlined"
//     startIcon={<CloudUploadIcon />}
//     onClick={handleOpenimport2}
//     sx={{
//       minWidth: 'auto',
//       backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//       borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//       color: mode === 'dark' ? '#fff' : '#1976d2',
//       '&:hover': {
//         backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//         borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//       }
//     }}
//   >
//     Import Leads
//   </Button> */}

//           {/* Quick Filter Button - الجديد */}
//           <Button
//             variant="outlined"
//             startIcon={<FilterListIcon />}
//             onClick={handleQuickFilterOpen}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Quick Filter
//           </Button>


// <Button
//   variant="outlined"
//   startIcon={<HistoryIcon />}
//   onClick={() => setAdminReportDialogOpen(true)}
//   sx={{
//     borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//     color: mode === 'dark' ? '#fff' : '#1976d2',
//     fontSize: isSmallScreen ? '0.75rem' : '0.875rem',
//     py: 1,
//   }}
// >
//   Sales Request Data Reports
// </Button>





//           {/* Refresh Button - بنفس ستايل Table Settings */}
//           <Button
//             variant="outlined"
//             startIcon={<SwapHorizIcon />}
//             onClick={handleRefreshData}
//             disabled={loadinggetdtaa}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//               '&:disabled': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//               },
//             }}
//           >
//             {loadinggetdtaa ? 'Refreshing...' : 'Refresh Data'}
//           </Button>

//           {/* Table Settings Button */}
//           <Button
//             variant="outlined"
//             startIcon={<SettingsIcon />}
//             onClick={() => setTableSettingsOpen(true)}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Table Settings
//           </Button>
//         </Box>
//       </Box>

//       {/* 🔍 عرض حالة البحث الحالي */}
//       {searchQuery && (
//         <Box
//           sx={{
//             mt: 2,
//             p: 2,
//             backgroundColor:
//               mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.05)',
//             borderRadius: 2,
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
//           >
//             <SearchIcon fontSize="small" />
//             <strong>Searching:</strong> "{searchQuery}"
//             {resleads?.pagination && (
//               <Chip
//                 label={`${resleads.pagination.totalItems} results`}
//                 size="small"
//                 color="primary"
//                 variant="outlined"
//               />
//             )}
//             <Button
//               size="small"
//               variant="outlined"
//               onClick={() => {
//                 localStorage.setItem('mainsearchstorage', '');
//                 window.dispatchEvent(new Event('mainsearchupdated'));
//               }}
//               sx={{ ml: 'auto' }}
//             >
//               Clear Search
//             </Button>
//           </Typography>
//           <Typography variant="caption" sx={{ display: 'block', mt: 1, fontFamily: 'monospace' }}>
//             Using keyword search in name, email, and phone
//           </Typography>
//         </Box>
//       )}

//       {/* Stats Cards */}
//       {resleads?.pagination && (
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
//           <Card sx={{ minWidth: 200, flexGrow: 1 }}>
//             <CardContent>
//               <Typography color="text.secondary" gutterBottom>
//                 Total Leads
//               </Typography>
//               <Typography variant="h5" component="div">
//                 {resleads.pagination.totalAllLeads}
//               </Typography>
//             </CardContent>
//           </Card>
//           <Card sx={{ minWidth: 200, flexGrow: 1 }}>
//             <CardContent>
//               <Typography color="text.secondary" gutterBottom>
//                 Active Leads
//               </Typography>
//               <Typography variant="h5" component="div" color="success.main">
//                 {resleads.pagination.totalLeadsActive}
//               </Typography>
//             </CardContent>
//           </Card>
//           <Card sx={{ minWidth: 200, flexGrow: 1 }}>
//             <CardContent>
//               <Typography color="text.secondary" gutterBottom>
//                 Inactive Leads
//               </Typography>
//               <Typography variant="h5" component="div" color="text.secondary">
//                 {resleads.pagination.totalLeadsInactive}
//               </Typography>
//             </CardContent>
//           </Card>
//           <Card sx={{ minWidth: 200, flexGrow: 1 }}>
//             <CardContent>
//               <Typography color="text.secondary" gutterBottom>
//                 Active Percentage
//               </Typography>
//               <Typography variant="h5" component="div" color="primary.main">
//                 {resleads.pagination.activePercentage}%
//               </Typography>
//             </CardContent>
//           </Card>
//         </Box>
//       )}

//       {loadinggetdtaa ? (
//         <Box
//           sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}
//         >
//           <CircularProgress />
//         </Box>
//       ) : (
//         <>
//           <TableContainer
//             component={Paper}
//             sx={{
//               borderRadius: 2,
//               boxShadow:
//                 mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)',
//               flexGrow: 1,
//               mb: 2,
//               overflow: 'auto',
//             }}
//           >
//             <Table sx={{ minWidth: 650 }} aria-label="leads table" size="small">
//               <TableHead
//                 sx={{
//                   backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//                 }}
//               >
//                 <TableRow>
//                   {getVisibleColumns().map((col) => (
//                     <TableCell
//                       key={col.key}
//                       sx={{
//                         color: tableConfig.whiteHeaders
//                           ? 'white'
//                           : mode === 'dark'
//                             ? 'white'
//                             : 'primary.contrastText',
//                         fontWeight: 'bold',
//                         width: `${col.width}px`,
//                         minWidth: `${col.width}px`,
//                         maxWidth: `${col.width}px`,
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                         fontSize: '0.875rem',
//                       }}
//                     >
//                       {col.key === 'selection' ? (
//                         <Checkbox
//                           checked={selectAll}
//                           onChange={handleSelectAll}
//                           sx={{
//                             color: 'white',
//                             '&.Mui-checked': {
//                               color: 'white',
//                             },
//                           }}
//                         />
//                       ) : (
//                         col.label
//                       )}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {resleads?.data?.length > 0 ? (
//                   resleads.data.map((lead) => (
//                     <StyledTableRow key={lead._id}>
//                       {getVisibleColumns().map((col) => (
//                         <TableCell
//                           key={col.key}
//                           sx={{
//                             width: `${col.width}px`,
//                             minWidth: `${col.width}px`,
//                             maxWidth: `${col.width}px`,
//                             verticalAlign: 'top',
//                             overflow: 'hidden',
//                           }}
//                         >
//                           {renderCell(col, lead)}
//                         </TableCell>
//                       ))}
//                     </StyledTableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={getVisibleColumns().length} align="center" sx={{ py: 4 }}>
//                       <Typography variant="h6" color="text.secondary">
//                         {searchQuery ? 'No results found for your search' : 'No leads available'}
//                       </Typography>
//                       {searchQuery && (
//                         <Button
//                           variant="outlined"
//                           onClick={() => {
//                             localStorage.setItem('mainsearchstorage', '');
//                             window.dispatchEvent(new Event('mainsearchupdated'));
//                           }}
//                           sx={{ mt: 2 }}
//                         >
//                           Clear Search
//                         </Button>
//                       )}
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           {/* Fixed Pagination Container at Bottom */}
//           {resleads?.data?.length > 0 && (
//             <Paper
//               elevation={3}
//               sx={{
//                 position: 'sticky',
//                 bottom: 0,
//                 left: 0,
//                 right: 0,
//                 zIndex: 1000,
//                 p: 2,
//                 borderRadius: 2,
//                 backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff',
//                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                 mt: 2,
//               }}
//             >
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   flexDirection: isSmallScreen ? 'column' : 'row',
//                   gap: 2,
//                   flexWrap: 'wrap',
//                 }}
//               >
//                 {/* Items Per Page Selector */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Typography variant="body2" color="text.secondary">
//                     Items per page:
//                   </Typography>
//                   <TextField
//                     select
//                     value={itemsPerPage}
//                     onChange={handleItemsPerPageChange}
//                     size="small"
//                     sx={{ minWidth: 80 }}
//                   >
//                     <MenuItem value={25}>25</MenuItem>
//                     <MenuItem value={50}>50</MenuItem>
//                     <MenuItem value={100}>100</MenuItem>
//                     <MenuItem value={250}>250</MenuItem>
//                   </TextField>
//                 </Box>

//                 {/* Page Info - نعرض الصفحة الحالية فقط إذا فيه أكثر من صفحة */}
//                 {resleads.pagination?.NumberOfPages > 1 && (
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Page {currentPage} of {resleads.pagination.NumberOfPages}
//                     </Typography>
//                     <Button
//                       variant="outlined"
//                       size="small"
//                       onClick={handleOpenGoToPage}
//                       startIcon={<SearchIcon />}
//                       sx={{ ml: 1 }}
//                     >
//                       Go to Page
//                     </Button>
//                   </Box>
//                 )}

//                 {/* Pagination Component - نعرضه فقط إذا فيه أكثر من صفحة */}
//                 {resleads.pagination?.NumberOfPages > 1 ? (
//                   <Pagination
//                     count={resleads.pagination.NumberOfPages}
//                     page={currentPage}
//                     onChange={handlePageChange}
//                     color="primary"
//                     size={isSmallScreen ? 'small' : 'medium'}
//                     showFirstButton
//                     showLastButton
//                   />
//                 ) : (
//                   <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
//                     📄 Single Page
//                   </Typography>
//                 )}

//                 {/* Results Info */}
//                 <Typography variant="body2" color="text.secondary">
//                   Showing <strong>{resleads.data.length}</strong> of{' '}
//                   <strong>{resleads.pagination?.totalItems || resleads.data.length}</strong> results
//                   {(searchQuery || Object.keys(appliedFilters).length > 0) && (
//                     <Chip
//                       label="Filtered"
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ ml: 1 }}
//                     />
//                   )}
//                 </Typography>
//               </Box>
//             </Paper>
//           )}
//         </>
//       )}

//       {/* Selection Snackbar */}
//       <Snackbar
//         open={snackbarOpen}
//         onClose={handleCloseassign}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//         message={`${selectedLeads.length} lead(s) selected`}
//         action={action}
//         sx={{
//           '& .MuiSnackbar-root': {
//             position: 'fixed',
//           },
//         }}
//       />

//       {/* AssignLeadsModal */}
//       {showAssignModal && (
//         <AssignLeadsModal
//           show={showAssignModal}
//           onHide={handleCloseAssignModal}
//           refreshData={handleRefreshData}
//         />
//       )}

//       {/* Go to Page Dialog */}
//       <Dialog open={goToPageDialog} onClose={handleCloseGoToPage} maxWidth="xs" fullWidth>
//         <DialogTitle>Go to Page</DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Page Number"
//             type="number"
//             fullWidth
//             variant="outlined"
//             value={pageInput}
//             onChange={(e) => setPageInput(e.target.value)}
//             inputProps={{
//               min: 1,
//               max: resleads?.pagination?.NumberOfPages,
//             }}
//             helperText={`Enter a page number between 1 and ${resleads?.pagination?.NumberOfPages}`}
//             onKeyPress={(e) => {
//               if (e.key === 'Enter') {
//                 handleGoToPage();
//               }
//             }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseGoToPage}>Cancel</Button>
//           <Button
//             onClick={handleGoToPage}
//             variant="contained"
//             disabled={
//               !pageInput ||
//               parseInt(pageInput) < 1 ||
//               parseInt(pageInput) > resleads?.pagination?.NumberOfPages
//             }
//           >
//             Go
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Table Settings Drawer */}
//       <Drawer
//         anchor="right"
//         open={tableSettingsOpen}
//         onClose={() => setTableSettingsOpen(false)}
//         PaperProps={{
//           sx: {
//             width: isSmallScreen ? '100%' : 400,
//             backgroundColor: mode === 'dark' ? '#1a1a1a' : '#ffffff',
//             backgroundImage: 'none',
//             marginTop: '25px',
//           },
//         }}
//       >
//         <Box sx={{ p: 3 }}>
//           <Typography
//             variant="h6"
//             gutterBottom
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#000000',
//               fontWeight: 'bold',
//             }}
//           >
//             🛠️ Table Columns Settings
//           </Typography>

//           {/* Export Buttons Section */}
//           <Box sx={{ mb: 2 }}>
//             <Typography
//               variant="subtitle2"
//               sx={{
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.9)',
//                 fontWeight: '600',
//                 mb: 1,
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1,
//               }}
//             >
//               <SystemUpdateAltIcon fontSize="small" />
//               Export Options
//             </Typography>

//             {/* Export Leads Data To Excel Sheet */}
//             <Button
//               variant="outlined"
//               fullWidth
//               startIcon={<SystemUpdateAltIcon />}
//               onClick={exportFilteredToExcel}
//               sx={{
//                 mb: 1,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(25,118,210,0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                 color: mode === 'dark' ? '#fff' : '#fff',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.08)',
//                   borderColor: mode === 'dark' ? '#fff' : '#fff',
//                 },
//               }}
//             >
//               Export Leads Data To Excel With Last Comment
//             </Button>

//             {/* Export Leads To Excel with Last Comments */}
//             <Button
//               variant="outlined"
//               fullWidth
//               startIcon={<SystemUpdateAltIcon />}
//               onClick={exportFilteredLeadsWithAllComments}
//               disabled={!resleads?.data?.length}
//               sx={{
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(25,118,210,0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                 color: mode === 'dark' ? '#fff' : '#fff',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.08)',
//                   borderColor: mode === 'dark' ? '#fff' : '#fff',
//                 },
//                 '&:disabled': {
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                   borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                 },
//               }}
//             >
//               Export with All Comments
//             </Button>
//           </Box>

//           <Divider
//             sx={{
//               my: 2,
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
//             }}
//           />

//           <Typography
//             variant="body2"
//             sx={{
//               mb: 3,
//               color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.7)',
//               fontSize: '0.875rem',
//             }}
//           >
//             Drag to reorder, toggle visibility, and adjust column widths
//           </Typography>

//           <Divider
//             sx={{
//               mb: 3,
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
//             }}
//           />

//           {/* Column Reordering Section */}
//           <Box sx={{ mb: 3 }}>
//             <Typography
//               variant="subtitle1"
//               gutterBottom
//               sx={{
//                 color: mode === 'dark' ? '#ffffff' : '#ffff',
//                 fontWeight: '600',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1,
//               }}
//             >
//               📋 Column Order & Visibility
//             </Typography>

//             <DragDropContext onDragEnd={handleDragEnd}>
//               <Droppable droppableId="columns">
//                 {(provided) => (
//                   <List
//                     {...provided.droppableProps}
//                     ref={provided.innerRef}
//                     sx={{
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//                       borderRadius: 2,
//                       p: 1,
//                     }}
//                   >
//                     {tableConfig.columnOrder.map((columnKey, index) => {
//                       const column = tableConfig.columns.find((col) => col.key === columnKey);
//                       if (!column) return null;

//                       return (
//                         <Draggable key={column.key} draggableId={column.key} index={index}>
//                           {(provided, snapshot) => (
//                             <ListItem
//                               ref={provided.innerRef}
//                               {...provided.draggableProps}
//                               {...provided.dragHandleProps}
//                               sx={{
//                                 border: '1px solid',
//                                 borderColor:
//                                   mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                                 borderRadius: 2,
//                                 mb: 1,
//                                 backgroundColor: snapshot.isDragging
//                                   ? mode === 'dark'
//                                     ? 'rgba(144, 202, 249, 0.2)'
//                                     : 'rgba(25, 118, 210, 0.1)'
//                                   : mode === 'dark'
//                                     ? 'rgba(255,255,255,0.03)'
//                                     : 'rgba(255,255,255,0.8)',
//                                 transition: 'all 0.2s ease',
//                                 '&:hover': {
//                                   backgroundColor:
//                                     mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
//                                   borderColor:
//                                     mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
//                                 },
//                               }}
//                             >
//                               <ListItemIcon sx={{ minWidth: 40 }}>
//                                 <Checkbox
//                                   checked={column.visible}
//                                   onChange={() => toggleColumnVisibility(column.key)}
//                                   icon={<VisibilityOffIcon />}
//                                   checkedIcon={<VisibilityIcon />}
//                                   sx={{
//                                     color:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                                     '&.Mui-checked': {
//                                       color: '#4caf50',
//                                     },
//                                   }}
//                                 />
//                               </ListItemIcon>

//                               <ListItemText
//                                 primary={
//                                   <Typography
//                                     sx={{
//                                       color: column.visible
//                                         ? mode === 'dark'
//                                           ? '#ffffff'
//                                           : '#000000'
//                                         : mode === 'dark'
//                                           ? 'rgba(255,255,255,0.4)'
//                                           : 'rgba(0,0,0,0.4)',
//                                       fontWeight: '500',
//                                       fontSize: '0.9rem',
//                                       textDecoration: column.visible ? 'none' : 'line-through',
//                                     }}
//                                   >
//                                     {column.label}
//                                   </Typography>
//                                 }
//                                 secondary={
//                                   <Typography
//                                     sx={{
//                                       color:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.5)'
//                                           : 'rgba(0,0,0,0.5)',
//                                       fontSize: '0.75rem',
//                                     }}
//                                   >
//                                     Width: {column.width}px
//                                   </Typography>
//                                 }
//                                 sx={{ flex: 1 }}
//                               />

//                               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                 {/* Width Control */}
//                                 <TextField
//                                   size="small"
//                                   type="number"
//                                   value={column.width}
//                                   onChange={(e) =>
//                                     updateColumnWidth(column.key, parseInt(e.target.value) || 100)
//                                   }
//                                   sx={{
//                                     width: 70,
//                                     '& .MuiInputBase-input': {
//                                       color: mode === 'dark' ? '#ffffff' : '#000000',
//                                       fontSize: '0.8rem',
//                                       padding: '6px 8px',
//                                       textAlign: 'center',
//                                     },
//                                     '& .MuiOutlinedInput-notchedOutline': {
//                                       borderColor:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.3)'
//                                           : 'rgba(0,0,0,0.3)',
//                                     },
//                                     '&:hover .MuiOutlinedInput-notchedOutline': {
//                                       borderColor: mode === 'dark' ? '#ffffff' : '#000000',
//                                     },
//                                   }}
//                                   inputProps={{
//                                     min: 60,
//                                     max: 400,
//                                     style: {
//                                       color: mode === 'dark' ? '#ffffff' : '#000000',
//                                     },
//                                   }}
//                                 />

//                                 {/* Drag Handle */}
//                                 <DragIndicatorIcon
//                                   sx={{
//                                     cursor: 'grab',
//                                     color:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                                     '&:hover': {
//                                       color: mode === 'dark' ? '#ffffff' : '#000000',
//                                     },
//                                   }}
//                                 />
//                               </Box>
//                             </ListItem>
//                           )}
//                         </Draggable>
//                       );
//                     })}
//                     {provided.placeholder}
//                   </List>
//                 )}
//               </Droppable>
//             </DragDropContext>
//           </Box>

//           {/* Action Buttons */}
//           <Box sx={{ display: 'flex', gap: 1, flexDirection: isSmallScreen ? 'column' : 'row' }}>
//             <Button
//               variant="outlined"
//               fullWidth
//               onClick={resetToDefault}
//               startIcon={<SettingsIcon />}
//               sx={{
//                 color: mode === 'dark' ? '#ffffff' : 'rgba(255,255,255,0.7)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 '&:hover': {
//                   borderColor: mode === 'dark' ? '#ffffff' : '#000000',
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.7)',
//                 },
//               }}
//             >
//               Reset Defaults
//             </Button>

//             <Button
//               variant="contained"
//               fullWidth
//               onClick={() => setTableSettingsOpen(false)}
//               startIcon={<CheckIcon />}
//               sx={{
//                 backgroundColor: '#1976d2',
//                 '&:hover': {
//                   backgroundColor: '#1565c0',
//                 },
//               }}
//             >
//               Apply Changes
//             </Button>
//           </Box>

//           {/* Quick Stats */}
//           <Box
//             sx={{
//               mt: 3,
//               p: 2,
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.05)',
//               borderRadius: 2,
//               border: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(25, 118, 210, 0.3)' : 'rgba(25, 118, 210, 0.2)',
//             }}
//           >
//             <Typography
//               variant="caption"
//               sx={{
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.7)',
//                 fontWeight: '500',
//               }}
//             >
//               📊 Current Setup:
//             </Typography>
//             <Typography
//               variant="caption"
//               sx={{
//                 display: 'block',
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.7)',
//               }}
//             >
//               {tableConfig.columns.filter((col) => col.visible).length} of{' '}
//               {tableConfig.columns.length} columns visible
//             </Typography>
//           </Box>
//         </Box>
//       </Drawer>
//     </Box>
//   );
// };





































// 20-5-2026
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, CircularProgress, Pagination,
  Avatar, TextField, MenuItem, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, IconButton, Checkbox, Tooltip,
  Drawer, Alert, Divider, Chip,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SevereColdIcon               from '@mui/icons-material/SevereCold';
import EditNoteIcon                  from '@mui/icons-material/EditNote';
import AssignmentTurnedInIcon        from '@mui/icons-material/AssignmentTurnedIn';
import FilterListIcon                from '@mui/icons-material/FilterList';
import RefreshIcon                   from '@mui/icons-material/Refresh';
import SettingsIcon                  from '@mui/icons-material/Settings';
import PersonAddIcon                 from '@mui/icons-material/PersonAdd';
import TransferWithinAStationIcon    from '@mui/icons-material/TransferWithinAStation';
import DeleteOutlineOutlinedIcon     from '@mui/icons-material/DeleteOutlineOutlined';
import CloseIcon                     from '@mui/icons-material/Close';
import SystemUpdateAltIcon           from '@mui/icons-material/SystemUpdateAlt';
import CheckIcon                     from '@mui/icons-material/Check';
import VisibilityIcon                from '@mui/icons-material/Visibility';
import VisibilityOffIcon             from '@mui/icons-material/VisibilityOff';
import AddCircleOutlineOutlinedIcon  from '@mui/icons-material/AddCircleOutlineOutlined';
import ContentCopyIcon               from '@mui/icons-material/ContentCopy';
import OpenInNewIcon                 from '@mui/icons-material/OpenInNew';
import HistoryIcon                   from '@mui/icons-material/History';
import SwapHorizIcon                 from '@mui/icons-material/SwapHoriz';
import moment                        from 'moment';
import { Link }                      from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ModeEditOutlineOutlinedIcon   from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveRedEyeOutlinedIcon      from '@mui/icons-material/RemoveRedEyeOutlined';
import { Getalldatasearch_For_Admin }  from '../../Redux/Actions/All_Leads_For_Admin_Action';
import { UpdateClientAction }          from '../../Redux/Actions/UsersAction';
import { Notify }                      from '../../Utility/Notify';
import { ClientTable2 }                from '../ClientTable2';
import { AssignLeadsModal }            from '../../Pages/AssignLeadsModal';
import { ShowClientsActionsAdvanced }  from '../../Pages/ShowClientsActionsAdvanced';
import { LeadDuplicationModal }        from '../../Pages/LeadDuplicationModal';
import QuickFilterModal                from '../../Pages/QuickFilterModal';
import { useSidebarWidth }             from '../../Utility/useSidebarWidth';
import { Admin_Report_Model_For_Requested_Data } from './Admin_Report_Model_For_Requested_Data';
import XLSX                            from '../../utils/excelUtils';
import axios                           from 'axios';
import { db_url }                      from '../../Api/BaseUrl';
import { BulkEditDrawer } from '../../Pages/BulkEditDrawer';

// ─── Design Tokens ───────────────────────────────────────────────────────────
const C = {
  bg:          '#F7F8FC',
  white:       '#FFFFFF',
  border:      '#E8EAF0',
  accent:      '#0D47A1',
  accentDark:  '#1330A6',
  accentSoft:  'rgba(26,62,207,0.07)',
  text:        '#1C2340',
  textMuted:   '#7B829A',
  success:     '#12B76A',
  successSoft: 'rgba(18,183,106,0.08)',
  warning:     '#F79009',
  danger:      '#F04438',
  dangerSoft:  'rgba(240,68,56,0.08)',
  shadow:      '0 1px 3px rgba(16,24,40,0.08)',
};

// ─── Styled Row ──────────────────────────────────────────────────────────────
const StyledRow = styled(TableRow)(() => ({
  '&:hover': { backgroundColor: 'rgba(26,62,207,0.03)' },
  '& td':    { borderBottom: `1px solid ${C.border}` },
}));

// ─── Stat Card ───────────────────────────────────────────────────────────────
const StatCard = ({ label, value, badge, highlight }) => (
  <Box sx={{
    bgcolor:      highlight ? C.accent : C.white,
    border:       `1px solid ${highlight ? C.accent : C.border}`,
    borderRadius: '12px',
    p: 2.5,
    width: 155, minWidth: 155, height: 115, minHeight: 115,
    boxShadow:    highlight ? '0 4px 16px rgba(26,62,207,0.25)' : C.shadow,
    position: 'relative', overflow: 'hidden', flexShrink: 0,
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
  }}>
    {badge && (
      <Box sx={{ position: 'absolute', top: 10, right: 10, bgcolor: C.success, color: '#fff', fontSize: '10px', fontWeight: 700, px: '6px', py: '2px', borderRadius: '20px', fontFamily: "'DM Sans', sans-serif" }}>
        {badge}
      </Box>
    )}
    <Typography sx={{ fontSize: '11px', fontWeight: 500, color: highlight ? 'rgba(255,255,255,0.75)' : C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif" }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: '26px', fontWeight: 700, color: highlight ? '#fff' : C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>
      {value != null ? String(value) : '—'}
    </Typography>
    {highlight && <Box sx={{ height: '3px', width: '40px', bgcolor: '#F79009', borderRadius: '2px' }} />}
  </Box>
);

// ─── Action Button ───────────────────────────────────────────────────────────
const ActionBtn = ({ icon, label, onClick, primary, disabled }) => (
  <Button onClick={onClick} disabled={disabled} startIcon={icon} size="small"
    sx={{
      fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '13px',
      borderRadius: '8px', textTransform: 'none', px: '14px', py: '7px',
      ...(primary
        ? { bgcolor: C.accent, color: '#fff', border: 'none', boxShadow: '0 2px 8px rgba(26,62,207,0.25)', '&:hover': { bgcolor: C.accentDark } }
        : { bgcolor: C.white, color: C.text, border: `1px solid ${C.border}`, '&:hover': { bgcolor: C.bg, borderColor: C.accent, color: C.accent } }
      ),
    }}
  >
    {label}
  </Button>
);

// ─── Phone Cell ──────────────────────────────────────────────────────────────
const PhoneCell = ({ user }) => {
  const [show, setShow] = useState(false);
  return (
    <Box onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <Typography sx={{ fontSize: '13px', color: C.text, mb: '4px', fontFamily: "'DM Sans', sans-serif" }}>
        {show ? user.phone : `${(user.phone || '').substring(0, 6)}···`}
      </Typography>
      <Box sx={{ display: 'flex', gap: '6px' }}>
        <IconButton size="small"
          onClick={() => window.open(`https://wa.me/${(user.phone || '').replace(/\D/g, '')}`, '_blank')}
          sx={{ width: 26, height: 26, bgcolor: 'rgba(37,211,102,0.1)', color: '#25D366', '&:hover': { bgcolor: 'rgba(37,211,102,0.2)' } }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </IconButton>
        <IconButton size="small"
          onClick={() => window.open(`tel:${user.phone}`)}
          sx={{ width: 26, height: 26, bgcolor: 'rgba(26,62,207,0.08)', color: C.accent, '&:hover': { bgcolor: 'rgba(26,62,207,0.15)' } }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
          </svg>
        </IconButton>
      </Box>
    </Box>
  );
};

// ─── Actions Menu ────────────────────────────────────────────────────────────
const ActionsMenu = ({ user, allusers }) => {
  const [anchorEl,    setAnchorEl]    = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showDelete,  setShowDelete]  = useState(false);
  const open      = Boolean(anchorEl);
  const closeMenu = () => setAnchorEl(null);

  return (
    <>
      <ClientTable2 user={user} allusers={allusers} showPreview={showPreview} setShowPreview={setShowPreview} showDelete={showDelete} setShowDelete={setShowDelete} />
      <IconButton size="small" onClick={e => { e.stopPropagation(); setAnchorEl(e.currentTarget); }}
        sx={{ width: 30, height: 30, borderRadius: '8px', color: C.textMuted, '&:hover': { bgcolor: C.accentSoft, color: C.accent }, transition: 'all 0.15s' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/>
        </svg>
      </IconButton>
      {open && (
        <Box onClick={e => e.stopPropagation()} sx={{
          position: 'fixed',
          top:  anchorEl ? anchorEl.getBoundingClientRect().bottom + 4 : 0,
          left: anchorEl ? Math.min(anchorEl.getBoundingClientRect().left - 160, window.innerWidth - 200) : 0,
          zIndex: 9999, bgcolor: C.white, borderRadius: '12px', border: `1px solid ${C.border}`,
          boxShadow: '0 8px 32px rgba(16,24,40,0.14)', minWidth: 200, py: '6px', overflow: 'hidden',
        }}>
          <Box onClick={closeMenu} sx={{ position: 'fixed', inset: 0, zIndex: -1 }} />
          <Box sx={{ px: '8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <Box component="a" href={`#/updateclient/${user._id}`} onClick={closeMenu}
              sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.text, textDecoration: 'none', fontSize: '13px', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: C.accentSoft, color: C.accent } }}>
              <ModeEditOutlineOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />
              Edit Lead
            </Box>
            <Box onClick={() => { closeMenu(); setShowPreview(true); }}
              sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.text, fontSize: '13px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: 'rgba(127,119,221,0.08)', color: '#7F77DD' } }}>
              <RemoveRedEyeOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />
              Preview Lead
            </Box>
            {!window.location.hash.includes('AllLeadsnotactivated') && (
              <>
                <Box sx={{ height: '1px', bgcolor: C.border, mx: '4px', my: '4px' }} />
                <Box onClick={() => { closeMenu(); setShowDelete(true); }}
                  sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.danger, fontSize: '13px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: 'rgba(240,68,56,0.06)' } }}>
                  <DeleteOutlineOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />
                  Delete Lead
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

// ─── Comment Cell ────────────────────────────────────────────────────────────
const CommentCell = ({ lead }) => {
  const [open, setOpen] = useState(false);
  const lc = lead.lastComment;
  const getInitialsLocal = (name) => !name ? '?' : name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  const tooltipContent = !lc ? (
    <Box sx={{ p: 3, textAlign: 'center', bgcolor: '#fff', borderRadius: '16px', minWidth: 200, boxShadow: '0 8px 32px rgba(16,24,40,0.12)', border: `1px solid ${C.border}` }}>
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#7B829A" strokeWidth="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      <Typography sx={{ color: C.textMuted, fontSize: '13px', fontFamily: "'DM Sans', sans-serif", mt: 1 }}>No comments yet</Typography>
    </Box>
  ) : (
    <Box sx={{ width: 380, bgcolor: '#fff', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(16,24,40,0.18)', border: `1px solid ${C.border}` }}>
      <Box sx={{ px: 3, py: 2, display: 'flex', alignItems: 'center', borderBottom: '1px solid #F0F2F8', bgcolor: '#FAFBFD' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ width: 44, height: 44, borderRadius: '50%', background: 'linear-gradient(135deg,#1A3ECF,#2E5AFF)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(26,62,207,0.25)' }}>
            <Typography sx={{ color: '#fff', fontSize: '15px', fontWeight: 700, fontFamily: "'DM Sans', sans-serif" }}>{getInitialsLocal(lc.sales?.name)}</Typography>
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '15px', color: '#1C2340', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3, mb: 0.5 }}>{lc.sales?.name || 'Unknown'}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
              {lc.stage?.name && (
                <Box sx={{ px: '10px', py: '3px', borderRadius: '30px', bgcolor: '#EEF1FD', display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#1A3ECF' }} />
                  <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#1A3ECF', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em' }}>{lc.stage.name}</Typography>
                </Box>
              )}
              {lc.firstcomment?.date && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#7B829A" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <Typography sx={{ fontSize: '11px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{moment(lc.firstcomment.date).format('DD/MM/YYYY h:mm A')}</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      {lc.firstcomment?.text && lc.firstcomment.text !== '-' && (
        <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ bgcolor: '#F8F9FF', borderRadius: '14px', px: 2, py: 1.5, borderLeft: '3px solid #1A3ECF' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1A3ECF" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
              <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1A3ECF', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em' }}>Comment</Typography>
            </Box>
            <Typography sx={{ fontSize: '13px', color: '#2A3458', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.55 }}>{lc.firstcomment.text}</Typography>
          </Box>
          {lc.secondcomment?.text && lc.secondcomment.text !== '-' && (
            <Box sx={{ bgcolor: '#FFF8F0', borderRadius: '14px', px: 2, py: 1.5, borderLeft: '3px solid #F59E0B' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2"><circle cx="12" cy="12" r="3"/></svg>
                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#F59E0B', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em' }}>Next Plan</Typography>
              </Box>
              <Typography sx={{ fontSize: '13px', color: '#2A3458', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.55 }}>{lc.secondcomment.text}</Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );

  return (
    <Tooltip open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} title={tooltipContent} placement="left-start" arrow={false}
      componentsProps={{ tooltip: { sx: { bgcolor: 'transparent', p: 0, m: 0, boxShadow: 'none', border: 'none', maxWidth: 'none', overflow: 'visible' } } }}>
      <Box onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
        <Box sx={{ width: 36, height: 36, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: lc ? 'rgba(26,62,207,0.08)' : 'rgba(123,130,154,0.08)', color: lc ? '#1A3ECF' : '#7B829A', position: 'relative', transition: 'all 0.2s', '&:hover': { bgcolor: lc ? 'rgba(26,62,207,0.15)' : 'rgba(123,130,154,0.15)', transform: 'scale(1.02)' } }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          {lc && <Box sx={{ position: 'absolute', top: 2, right: 2, width: 8, height: 8, borderRadius: '50%', bgcolor: '#12B76A', border: '1.5px solid #fff' }} />}
        </Box>
      </Box>
    </Tooltip>
  );
};

// ─── Column Config ───────────────────────────────────────────────────────────
const DEFAULT_COLS = [
  { key: 'dup',         label: 'Duplicate',     fieldId: 'DUP_STATUS',  w: 110, visible: true },
  { key: 'name',        label: 'Name',          fieldId: 'CLIENT_NAME', w: 200, visible: true },
  { key: 'phone',       label: 'Phone',         fieldId: 'CONTACT_PH',  w: 140, visible: true },
  { key: 'developer',   label: 'Developer',     fieldId: 'DEV_NAME',    w: 130, visible: true },
  { key: 'project',     label: 'Project',       fieldId: 'ASSET_ID',    w: 160, visible: true },
  { key: 'campaign',    label: 'Campaign',      fieldId: 'CAMP_ID',     w: 150, visible: true },
  { key: 'channel',     label: 'Channel',       fieldId: 'SRC_CHAN',    w: 130, visible: true },
  { key: 'sales',       label: 'Sales',         fieldId: 'SALES_REP',   w: 150, visible: true },
  { key: 'lastComment', label: 'Last Comment',  fieldId: 'LAST_CMT',    w: 60,  visible: true },
  { key: 'stage',       label: 'Stage',         fieldId: 'STAGE_ID',    w: 160, visible: true },
  { key: 'status',      label: 'Status',        fieldId: 'LEAD_STATUS', w: 100, visible: true },
  { key: 'addedBy',     label: 'Added By',      fieldId: 'ADDED_BY',    w: 150, visible: true },
  { key: 'createdAt',   label: 'Creation Date', fieldId: 'CREATE_DT',   w: 140, visible: true },
  { key: 'actions',     label: 'Actions',       fieldId: 'ACT_BTN',     w: 60,  visible: true },
];

const getInitials = (n = '') =>
  (n || '').split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

// ─── Main Component ──────────────────────────────────────────────────────────
export const AdminAllLeadsCRMData = () => {
  const isMobile  = useMediaQuery(useTheme().breakpoints.down('md'));
  const dispatch  = useDispatch();
  const location  = useLocation();
  const sidebarW  = useSidebarWidth();

  const resleads = useSelector(state => state.All_Leads_For_Admin_Reducer.AllLeads);

  // ── State ─────────────────────────────────────────────────────────────────
  const [loading,        setLoading]        = useState(true);
  const [currentPage,    setCurrentPage]    = useState(1);
  const [itemsPerPage,   setItemsPerPage]   = useState(25);
  const [searchQuery,    setSearchQuery]    = useState(localStorage.getItem('mainsearchstorage') || '');
  const [selectedLeads,  setSelectedLeads]  = useState(() => { try { return JSON.parse(localStorage.getItem('selectedleeds') || '[]'); } catch { return []; } });
  const [selectAll,      setSelectAll]      = useState(false);
  const [selectedLead,   setSelectedLead]   = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [userlogin,      setUserlogin]      = useState(null);
const [bulkEditOpen, setBulkEditOpen] = useState(false);

  const [colConfig, setColConfig] = useState(() => {
    try { const s = localStorage.getItem('crmDataColConfig'); return s ? JSON.parse(s) : DEFAULT_COLS; } catch { return DEFAULT_COLS; }
  });
  useEffect(() => { localStorage.setItem('crmDataColConfig', JSON.stringify(colConfig)); }, [colConfig]);

  // modals
  const [showAssign,      setShowAssign]      = useState(false);
  const [showDelete,      setShowDelete]      = useState(false);
  const [quickFilter,     setQuickFilter]     = useState(false);
  const [settingsOpen,    setSettingsOpen]    = useState(false);
  const [adminReportOpen, setAdminReportOpen] = useState(false);
  const [duplication,     setDuplication]     = useState({ open: false, leadId: null, leadName: '' });

  // Transfer to Original Leads
  const [tolOpen,    setTolOpen]    = useState(false);
  const [tolCount,   setTolCount]   = useState('');
  const [tolLoading, setTolLoading] = useState(false);
  const [tolError,   setTolError]   = useState('');

  const currentStageRef    = useRef('');
  const pendingRef         = useRef(null);
  const initialLoadDoneRef = useRef(false);

  useEffect(() => { const u = localStorage.getItem('user'); if (u) setUserlogin(JSON.parse(u)); }, []);
  useEffect(() => { localStorage.setItem('selectedleeds', JSON.stringify(selectedLeads)); }, [selectedLeads]);

  // ── Column helpers ────────────────────────────────────────────────────────
  const toggleColVisibility = (key) => setColConfig(p => p.map(c => c.key === key ? { ...c, visible: !c.visible } : c));
  const updateColWidth      = (key, w) => setColConfig(p => p.map(c => c.key === key ? { ...c, w: Math.max(60, Math.min(400, parseInt(w) || c.w)) } : c));
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(colConfig);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);
    setColConfig(items);
  };

  // ── Load ──────────────────────────────────────────────────────────────────
  const getSearchQuery = (s) => {
    if (!s) return '';
    const c = s.trim();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c)) return `email=${encodeURIComponent(c)}`;
    return `keyword=${encodeURIComponent(c)}`;
  };

    const getOutsourceParam = () => new URLSearchParams(location.search).get('outsource');

  const loadLeads = async (page = 1, limit = itemsPerPage, search = '', stage = '', dups = '', filters = {}, salesId = '', outsource = '') => {
  setLoading(true);
  let q = `leadisactive=true&limit=${limit}&page=${page}&sort=-date&data=false&transferefromdata=false`;
  if (search)  q += `&${getSearchQuery(search)}`;
  if (stage)   q += `&stage=${encodeURIComponent(stage)}`;
  if (dups === 'true') q += `&duplicates=true&ignoreduplicate=true`;
  if (salesId) q += `&sales=${encodeURIComponent(salesId)}`; // ✅
    if (outsource === 'true') q += `&outsource=true`; // ✅ جديد

  if (filters) {
    ['stage','sales','chanel','campaign','project','developer','addby'].forEach(k => {
      if (filters[k]?.length) {
        const ids = filters[k].map(i => i.id || i._id).filter(Boolean).join(',');
        if (ids) q += `&${k}=${encodeURIComponent(ids)}`;
      }
    });
    if (filters.oldstage?.length) {
      const ids = filters.oldstage.map(i => i.id || i._id).filter(Boolean).join(',');
      if (ids) q += `&oldstage=${encodeURIComponent(ids)}`;
    }
    if (filters.assignedFrom?.length) {
      const ids = filters.assignedFrom.map(i => i.id || i._id).filter(Boolean).join(',');
      if (ids) q += `&assignedFrom=${encodeURIComponent(ids)}`;
    }
    if (filters.assignedTo?.length) {
      const ids = filters.assignedTo.map(i => i.id || i._id).filter(Boolean).join(',');
      if (ids) q += `&assignedTo=${encodeURIComponent(ids)}`;
    }
    if (filters.createdAt?.from)        q += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
    if (filters.createdAt?.to)          q += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
    if (filters.stagedateupdated?.from) q += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
    if (filters.stagedateupdated?.to)   q += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
    if (filters.budget)                 q += `&budget=${encodeURIComponent(filters.budget)}`;
  }
  try { await dispatch(Getalldatasearch_For_Admin(q)); } catch (e) { console.error(e); } finally { setLoading(false); }
};

// useEffect(() => {
//   const sp      = new URLSearchParams(location.search);
//   const stage   = sp.get('stage');
//   const dups    = sp.get('duplicates');
//   const salesId = sp.get('salesId'); // ✅
//   const key     = stage || dups || salesId || 'all';

//   if (currentStageRef.current !== key || !initialLoadDoneRef.current) {
//     if (pendingRef.current) clearTimeout(pendingRef.current);
//     setCurrentPage(1);
//     currentStageRef.current = key;
//     pendingRef.current = setTimeout(() => {
//       loadLeads(1, itemsPerPage, searchQuery, stage, dups, appliedFilters, salesId); // ✅
//       initialLoadDoneRef.current = true;
//     }, 300);
//   }
//   return () => { if (pendingRef.current) clearTimeout(pendingRef.current); };
// }, [location.search, searchQuery, appliedFilters]);



useEffect(() => {
  const sp        = new URLSearchParams(location.search);
  const stage     = sp.get('stage');
  const dups      = sp.get('duplicates');
  const salesId   = sp.get('salesId'); // ✅
  const outsource = sp.get('outsource'); // ✅ جديد
  const key       = stage || dups || salesId || outsource || 'all'; // ✅ عدّلنا الـ key كمان

  if (currentStageRef.current !== key || !initialLoadDoneRef.current) {
    if (pendingRef.current) clearTimeout(pendingRef.current);
    setCurrentPage(1);
    currentStageRef.current = key;
    pendingRef.current = setTimeout(() => {
      loadLeads(1, itemsPerPage, searchQuery, stage, dups, appliedFilters, salesId, outsource); // ✅
      initialLoadDoneRef.current = true;
    }, 300);
  }
  return () => { if (pendingRef.current) clearTimeout(pendingRef.current); };
}, [location.search, searchQuery, appliedFilters]);

  // useEffect(() => {
  //   const handler = () => {
  //     const v = localStorage.getItem('mainsearchstorage') || '';
  //     setSearchQuery(v); setCurrentPage(1);
  //     const sp = new URLSearchParams(location.search);
  //     loadLeads(1, itemsPerPage, v, sp.get('stage'), sp.get('duplicates'));
  //   };
  //   window.addEventListener('mainsearchupdated', handler);
  //   return () => window.removeEventListener('mainsearchupdated', handler);
  // }, [itemsPerPage, location.search]);



  useEffect(() => {
  const handler = () => {
    const v = localStorage.getItem('mainsearchstorage') || '';
    setSearchQuery(v);
    setCurrentPage(1);
    const sp = new URLSearchParams(location.search);
    loadLeads(
      1,
      itemsPerPage,
      v,
      sp.get('stage'),
      sp.get('duplicates'),
      appliedFilters,        // ✅ ضفناها - كانت ناقصة خالص
      sp.get('salesId'),     // ✅ ضفناها
      getOutsourceParam(),   // ✅ ضفناها
    );
  };
  window.addEventListener('mainsearchupdated', handler);
  return () => window.removeEventListener('mainsearchupdated', handler);
}, [itemsPerPage, location.search, appliedFilters]); // ✅ ضفنا appliedFilters في الـ dependencies كمان

  // ── Selection ─────────────────────────────────────────────────────────────
  const toggleLead = (id) => { const y = window.scrollY; setSelectedLeads(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]); setTimeout(() => window.scrollTo(0, y), 10); };
  const toggleAll  = () => { const y = window.scrollY; if (selectAll) { setSelectedLeads([]); setSelectAll(false); } else { setSelectedLeads(resleads?.data?.map(l => l._id) || []); setSelectAll(true); } setTimeout(() => window.scrollTo(0, y), 10); };

  const handleAssign   = () => { if (!selectedLeads.length) return; localStorage.setItem('action', 'Assign'); setShowAssign(true); };
  const handleTransfer = () => {
    if (!selectedLeads.length) return;
    const allTransfer = (resleads?.data?.filter(l => selectedLeads.includes(l._id)) || []).every(l => l.stage?.name === 'Transfer');
    if (!allTransfer) { Notify('error', 'This is for Transfer Leads only', 'error'); return; }
    localStorage.setItem('action', 'Transfer'); setShowAssign(true);
  };
const handleDelete = async () => {
  await Promise.all(selectedLeads.map(id => dispatch(UpdateClientAction(id, { leadisactive: 'false' }))));
  Notify('success', 'Leads deleted', 'success');
  setShowDelete(false); setSelectedLeads([]);
  const sp = new URLSearchParams(location.search);
  loadLeads(
    1,
    itemsPerPage,
    searchQuery,
    sp.get('stage'),
    sp.get('duplicates'),
    appliedFilters,          // ✅ كانت أصلاً ناقصة برضو
    sp.get('salesId'),       // ✅ ضفناها
    getOutsourceParam(),     // ✅ ضفناها
  );
};

  // ── Transfer to Original ──────────────────────────────────────────────────
 const confirmTransferToOriginal = async () => {
  if (parseInt(tolCount) !== selectedLeads.length) { setTolError(`Enter exactly ${selectedLeads.length} to confirm`); return; }
  setTolLoading(true);
  try {
    await Promise.all(selectedLeads.map(id => dispatch(UpdateClientAction(id, { transferefromdata: 'true' }))));
    Notify('success', `${selectedLeads.length} lead(s) moved to Original Leads`, 'success');
    setTolOpen(false); setSelectedLeads([]); setSelectAll(false); setTolCount(''); setTolError('');
    const sp = new URLSearchParams(location.search);
    loadLeads(
      1,
      itemsPerPage,
      searchQuery,
      sp.get('stage'),
      sp.get('duplicates'),
      appliedFilters,
      sp.get('salesId'),      // ✅ ضفناها
      getOutsourceParam(),    // ✅ ضفناها
    );
  } catch (e) { setTolError(e.message || 'Transfer failed'); }
  finally { setTolLoading(false); }
};

  // ── Ignore duplicate ──────────────────────────────────────────────────────
  const searchParams2    = new URLSearchParams(location.search);
  const duplicates2      = searchParams2.get('duplicates');
  const ignoreduplicate2 = searchParams2.get('ignoreduplicate');

const handleIgnoreDuplicate = async () => {
  if (!selectedLeads.length) { Notify('error', 'Select at least one lead', 'error'); return; }
  await Promise.all(selectedLeads.map(id => dispatch(UpdateClientAction(id, { ignoredublicate: 'false' }))));
  Notify('success', 'Leads ignored duplicate successfully', 'success');
  setSelectedLeads([]); setSelectAll(false); setCurrentPage(1);
  const sp = new URLSearchParams(location.search);
  loadLeads(
    1,
    itemsPerPage,
    searchQuery,
    sp.get('stage'),
    sp.get('duplicates'),
    appliedFilters,
    sp.get('salesId'),      // ✅ ضفناها
    getOutsourceParam(),    // ✅ ضفناها
  );
};

  // ── Export ────────────────────────────────────────────────────────────────
  const exportExcel = () => {
    const data = (resleads?.data || []).map(u => ({ Name: u.name||'', Email: u.email||'', Phone: u.phone||'', Project: u.project?.name||'', Developer: u.project?.developer?.name||'', Campaign: u.campaign?.CampainName||'', Channel: u.chanel?.name||'', Sales: u.sales?.name||'', Stage: u.stage?.name||'', 'Stage Date': u.stagedateupdated ? moment(u.stagedateupdated).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A') : '', Status: u.leadisactive === 'true' ? 'Active' : 'Inactive', 'Last Comment': u.lastComment?.firstcomment?.text||'', 'Action Plan': u.lastComment?.secondcomment?.text||'', 'Added By': u.addby?.name||'', 'Creation Date': u.date ? moment(u.date).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A') : '' }));
    const ws = XLSX.utils.json_to_sheet(data); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Leads');
    XLSX.writeFile(wb, `DataCenter_Leads_${moment().format('YYYY-MM-DD')}.xlsx`);
    Notify('success', `Exported ${data.length} leads`, 'success');
  };

  const exportAllComments = async () => {
    Notify('info', 'Preparing export...', 'info');
    try {
      const response = await axios.get(`${db_url}api/v1/Action`);
      const allActions = response.data.data;
      const data = (resleads?.data || []).map(lead => {
        const acts = allActions.filter(a => a.leed?._id === lead._id);
        const comments = acts.flatMap(a => a.Comments || []).sort((a, b) => new Date(a.stageDate || a.createdAt) - new Date(b.stageDate || b.createdAt));
        const formatted = comments.map((c, i) => `(${i+1}) [${moment(c.stageDate || c.createdAt).format('DD/MM/YYYY')}] Stage: ${c.stage?.name||'N/A'} | By: ${c.sales?.name||'N/A'}\nComment: ${c.firstcomment?.text||''}\nNext: ${c.secondcomment?.text||''}`).join('\n\n');
        return { Name: lead.name||'', Email: lead.email||'', Phone: lead.phone||'', Sales: lead.sales?.name||'', Stage: lead.stage?.name||'', 'All Comments': formatted||'No Comments' };
      });
      const ws = XLSX.utils.json_to_sheet(data); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Leads');
      XLSX.writeFile(wb, `DataCenter_AllComments_${moment().format('YYYY-MM-DD')}.xlsx`);
      Notify('success', 'Exported with all comments', 'success');
    } catch { Notify('error', 'Export failed', 'error'); }
  };

 const refresh = () => {
    setCurrentPage(1); setSelectedLeads([]); setSelectAll(false);
    const sp = new URLSearchParams(location.search);
    loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters, sp.get('salesId'), getOutsourceParam());
  };

  const pagination = resleads?.pagination;

  // ── JSX ───────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ ml: isMobile ? '64px' : `${sidebarW}px`, mt: '64px', minHeight: 'calc(100vh - 64px)', bgcolor: C.bg, transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)' }}>
      <Box sx={{ p: isMobile ? 2 : 3.5 }}>

        {/* ── Header ── */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
          <Box>
            <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 800, fontSize: isMobile ? '28px' : '36px', color: C.text, lineHeight: 1.15, letterSpacing: '-0.02em' }}>
              Data Center<br />Management
            </Typography>
            <Typography sx={{ fontSize: '13.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", mt: 1, maxWidth: 340 }}>
              Manage and track all leads in the Data Center with real-time insights.
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'stretch' }}>
            <StatCard label="Total Leads"  value={pagination?.totalAllLeads}    badge="+NEW" highlight />
            <StatCard label="Active Leads" value={pagination?.totalLeadsActive} />
            <StatCard label="Trash"     value={pagination?.totalLeadsInactive} />
            {/* <StatCard label="Conv. Rate"   value={pagination?.activePercentage != null ? `${pagination.activePercentage}%` : null} highlight /> */}
          </Box>
        </Box>

        {/* ── Table Card ── */}
        <Box sx={{ bgcolor: C.white, borderRadius: '12px', border: `1px solid ${C.border}`, boxShadow: C.shadow, overflow: 'hidden' }}>

          {/* Toolbar */}
          <Box sx={{ px: 2.5, py: 1.8, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', borderBottom: `1px solid ${C.border}`, minHeight: 56 }}>
            {selectedLeads.length > 0 ? (
              <>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', px: '12px', py: '5px', bgcolor: C.accent, borderRadius: '20px', boxShadow: '0 2px 8px rgba(13,71,161,0.25)', flexShrink: 0 }}>
                  <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#fff', opacity: 0.8 }} />
                  <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#fff', fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap' }}>{selectedLeads.length} selected</Typography>
                </Box>
                <Box sx={{ width: '1px', height: '22px', bgcolor: C.border, flexShrink: 0 }} />
                {duplicates2 === 'true' && ignoreduplicate2 === 'true' && (
                  <Tooltip title="Ignore Duplicate">
                    <Button size="small" onClick={handleIgnoreDuplicate} sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '12.5px', textTransform: 'none', borderRadius: '8px', px: '12px', py: '5px', color: '#9c27b0', bgcolor: 'rgba(156,39,176,0.07)', border: '1px solid rgba(156,39,176,0.18)', '&:hover': { bgcolor: 'rgba(156,39,176,0.13)' }, gap: '6px' }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13H5v-2h14v2z"/></svg>
                      Ignore Dup.
                    </Button>
                  </Tooltip>
                )}
                <Tooltip title="Move to Original Leads">
                  <Button size="small" onClick={() => { setTolCount(''); setTolError(''); setTolOpen(true); }} startIcon={<SwapHorizIcon sx={{ fontSize: '16px !important' }} />}
                    sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '12.5px', textTransform: 'none', borderRadius: '8px', px: '12px', py: '5px', color: '#0891b2', bgcolor: 'rgba(8,145,178,0.07)', border: '1px solid rgba(8,145,178,0.18)', '&:hover': { bgcolor: 'rgba(8,145,178,0.13)' } }}>
                    To Original
                  </Button>
                </Tooltip>


                  <Tooltip title="Bulk Edit">
                  <Button size="small" onClick={() => { setBulkEditOpen(true);  }} startIcon={<SwapHorizIcon sx={{ fontSize: '16px !important' }} />}
                    sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '12.5px', textTransform: 'none', borderRadius: '8px', px: '12px', py: '5px', color: '#0891b2', bgcolor: 'rgba(8,145,178,0.07)', border: '1px solid rgba(8,145,178,0.18)', '&:hover': { bgcolor: 'rgba(8,145,178,0.13)' } }}>
                    Bulk Edit
                  </Button>
                </Tooltip>


                <Tooltip title="Assign to Sales">
                  <Button size="small" onClick={handleAssign} startIcon={<PersonAddIcon sx={{ fontSize: '15px !important' }} />}
                    sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '12.5px', textTransform: 'none', borderRadius: '8px', px: '12px', py: '5px', color: '#16a34a', bgcolor: 'rgba(22,163,74,0.07)', border: '1px solid rgba(22,163,74,0.18)', '&:hover': { bgcolor: 'rgba(22,163,74,0.13)' } }}>
                    Assign
                  </Button>
                </Tooltip>
                <Tooltip title="Transfer (stage)">
                  <Button size="small" onClick={handleTransfer} startIcon={<TransferWithinAStationIcon sx={{ fontSize: '15px !important' }} />}
                    sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '12.5px', textTransform: 'none', borderRadius: '8px', px: '12px', py: '5px', color: '#b45309', bgcolor: 'rgba(180,83,9,0.07)', border: '1px solid rgba(180,83,9,0.18)', '&:hover': { bgcolor: 'rgba(180,83,9,0.13)' } }}>
                    Transfer
                  </Button>
                </Tooltip>
                <Tooltip title="Delete selected">
                  <Button size="small" onClick={() => setShowDelete(true)} startIcon={<DeleteOutlineOutlinedIcon sx={{ fontSize: '16px !important' }} />}
                    sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '12.5px', textTransform: 'none', borderRadius: '8px', px: '12px', py: '5px', color: C.danger, bgcolor: C.dangerSoft, border: `1px solid rgba(240,68,56,0.18)`, '&:hover': { bgcolor: 'rgba(240,68,56,0.12)' } }}>
                    Delete
                  </Button>
                </Tooltip>
                <Box sx={{ flex: 1 }} />
                <Tooltip title="Clear selection">
                  <IconButton size="small" onClick={() => { setSelectedLeads([]); setSelectAll(false); }}
                    sx={{ width: 28, height: 28, borderRadius: '7px', color: C.textMuted, bgcolor: 'rgba(123,130,154,0.08)', '&:hover': { bgcolor: 'rgba(123,130,154,0.16)', color: C.text } }}>
                    <CloseIcon sx={{ fontSize: '16px' }} />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <>
                <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '16px', color: C.text, flex: 1 }}>Live Pipeline — Data Center</Typography>
                {searchQuery && (
                 <Chip label={`"${searchQuery}" · ${pagination?.totalItems || 0} results`} size="small"
    onDelete={() => { localStorage.setItem('mainsearchstorage', ''); window.dispatchEvent(new Event('mainsearchupdated')); }}
                    sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: '12px', bgcolor: C.accentSoft, color: C.accent, border: `1px solid rgba(26,62,207,0.2)` }} />
                )}
                <Tooltip title="Quick Filter"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={() => setQuickFilter(true)}><FilterListIcon fontSize="small" /></IconButton></Tooltip>
                <Tooltip title="Refresh"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={refresh} disabled={loading}><RefreshIcon fontSize="small" /></IconButton></Tooltip>
                <Tooltip title="Table settings & Export"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={() => setSettingsOpen(true)}><SettingsIcon fontSize="small" /></IconButton></Tooltip>
                <Box sx={{ width: '1px', height: '20px', bgcolor: C.border }} />
                <ActionBtn icon={<HistoryIcon />} label="Sales Reports" onClick={() => setAdminReportOpen(true)} />
                <Link to="/addclient" style={{ textDecoration: 'none' }}>
                  <ActionBtn icon={<AddCircleOutlineOutlinedIcon />} label="New Lead" primary />
                </Link>
              </>
            )}
          </Box>

          {/* Table */}
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table size="small" sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 52, minWidth: 52, py: '10px', px: '12px', borderBottom: `2px solid ${C.border}` }}>
                    <Checkbox size="small" checked={selectAll} onChange={toggleAll} sx={{ color: C.textMuted }} />
                  </TableCell>
                  {colConfig.filter(c => c.visible).map(col => (
                    <TableCell key={col.key} sx={{ width: col.w, minWidth: col.w, py: '10px', px: '12px', fontFamily: "'DM Sans', sans-serif", fontSize: '11.5px', fontWeight: 600, color: C.textMuted, letterSpacing: '0.05em', textTransform: 'uppercase', borderBottom: `2px solid ${C.border}`, whiteSpace: 'nowrap' }}>
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={colConfig.filter(c => c.visible).length + 1} align="center" sx={{ py: 6 }}><CircularProgress size={32} sx={{ color: C.accent }} /></TableCell></TableRow>
                ) : !resleads?.data?.length ? (
                  <TableRow><TableCell colSpan={colConfig.filter(c => c.visible).length + 1} align="center" sx={{ py: 6 }}>
                    <Typography sx={{ color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{searchQuery ? 'No results found for your search' : 'No leads available'}</Typography>
                  </TableCell></TableRow>
                ) : resleads.data.map(lead => (
                  <StyledRow key={lead._id}>
                    <TableCell sx={{ px: '12px', py: '10px' }}>
                      <Checkbox size="small" checked={selectedLeads.includes(lead._id)} onChange={() => toggleLead(lead._id)} sx={{ color: C.textMuted, '&.Mui-checked': { color: C.accent } }} />
                    </TableCell>

                    {/* Duplicate */}
                    {colConfig.find(c=>c.key==='dup')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Box onClick={() => setDuplication({ open: true, leadId: lead._id, leadName: lead.name })}
                          sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px', px: '10px', py: '4px', borderRadius: '20px', border: `1px solid ${C.border}`, fontSize: '12px', fontWeight: 500, cursor: 'pointer', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", '&:hover': { borderColor: C.accent, color: C.accent } }}>
                          <Box component="span" sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: C.accentSoft, color: C.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 700 }}>{lead.totalSubmissions || 0}</Box>
                          Reg.
                        </Box>
                      </TableCell>
                    )}

                    {/* Name */}
                    {colConfig.find(c=>c.key==='name')?.visible && (
                      <TableCell sx={{ px: '12px', cursor: 'pointer' }} onClick={() => setSelectedLead(lead)}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <Avatar sx={{ width: 34, height: 34, fontSize: '12px', fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, fontFamily: "'DM Sans', sans-serif" }}>{getInitials(lead.name)}</Avatar>
                          <Box>
                            <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3 }}>{lead.name}</Typography>
                            <Typography sx={{ fontSize: '12px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.email}</Typography>
                          </Box>
                        </Box>
                      </TableCell>
                    )}

                    {/* Phone */}
                    {colConfig.find(c=>c.key==='phone')?.visible && <TableCell sx={{ px: '12px' }}><PhoneCell user={lead} /></TableCell>}

                    {/* Developer */}
                    {colConfig.find(c=>c.key==='developer')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.project?.developer?.name || '—'}</Typography>
                      </TableCell>
                    )}

                    {/* Project */}
                    {colConfig.find(c=>c.key==='project')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Typography sx={{ fontSize: '13px', fontWeight: 500, color: C.text, fontFamily: "'DM Sans', sans-serif" }}>{lead.project?.name || '—'}</Typography>
                      </TableCell>
                    )}

                    {/* Campaign */}
                    {colConfig.find(c=>c.key==='campaign')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Typography sx={{ fontSize: '13px', color: lead.campaign?.redirectLink ? C.accent : C.textMuted, fontWeight: lead.campaign?.redirectLink ? 500 : 400, fontFamily: "'DM Sans', sans-serif" }}>
                          {lead.campaign?.CampainName || '—'}
                        </Typography>
                        {lead.campaign?.redirectLink && (
                          <Box sx={{ display: 'flex', gap: '4px', mt: '4px' }}>
                            <IconButton size="small" onClick={e => { e.stopPropagation(); navigator.clipboard.writeText(lead.campaign.redirectLink); Notify('success', 'Link copied', 'success'); }}
                              sx={{ width: 22, height: 22, color: C.textMuted, '&:hover': { color: C.accent } }}>
                              <ContentCopyIcon sx={{ fontSize: '14px' }} />
                            </IconButton>
                            <IconButton size="small" onClick={e => { e.stopPropagation(); window.open(lead.campaign.redirectLink, '_blank'); }}
                              sx={{ width: 22, height: 22, color: C.textMuted, '&:hover': { color: C.success } }}>
                              <OpenInNewIcon sx={{ fontSize: '14px' }} />
                            </IconButton>
                          </Box>
                        )}
                      </TableCell>
                    )}

                    {/* Channel */}
                    {colConfig.find(c=>c.key==='channel')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.chanel?.name || '—'}</Typography>
                      </TableCell>
                    )}

                    {/* ── Sales — with TL badge ── */}
                    {colConfig.find(c=>c.key==='sales')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Tooltip
                          title={lead.assigntype === true
                            ? `Team: ${lead.sales?.name||'N/A'} | Leader: ${lead.sales?.teamleader?.name||'N/A'}`
                            : `Team Leader: ${lead.sales?.teamleader?.name||'N/A'}`
                          }
                          arrow placement="top"
                        >
                          <Box sx={{ display:'flex', alignItems:'center', gap:'8px', cursor:'default' }}>
                            <Avatar sx={{
                              width:30, height:30, fontSize:'11px', fontWeight:700, flexShrink:0,
                              fontFamily:"'DM Sans',sans-serif",
                              bgcolor: lead.assigntype === true ? 'rgba(13,71,161,0.12)' : 'rgba(247,144,9,0.12)',
                              color:   lead.assigntype === true ? C.accent : '#B54708',
                            }}>
                              {lead.assigntype === true ? 'T' : getInitials(lead.sales?.name)}
                            </Avatar>
                            <Box>
                              <Box sx={{ display:'flex', alignItems:'center', gap:'5px' }}>
                                {lead.assigntype === true && (
                                  <Box sx={{
                                    fontSize:'9px', fontWeight:800, color:'#fff',
                                    bgcolor: C.accent, borderRadius:'4px',
                                    px:'4px', py:'1px', lineHeight:1.4,
                                    fontFamily:"'DM Sans',sans-serif", letterSpacing:'0.04em',
                                  }}>
                                    TL
                                  </Box>
                                )}
                                <Typography sx={{
                                  fontSize:'13px',
                                  fontWeight: lead.assigntype === true ? 700 : 500,
                                  color: lead.assigntype === true ? C.accent : C.text,
                                  fontFamily:"'DM Sans',sans-serif", lineHeight:1.3,
                                }}>
                                  {lead.assigntype === true
                                    ? (lead.sales?.teamleader?.name || lead.sales?.name || '—')
                                    : (lead.sales?.name || '—')
                                  }
                                </Typography>
                              </Box>
                              {lead.lastdateassign && (
                                <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>
                                  {moment(lead.lastdateassign).format('DD/MM/YY HH:mm')}
                                </Typography>
                              )}

                              {lead.assign === true && (
  <Box sx={{ display:'flex', alignItems:'center', gap:'4px', mt:'3px' }}>
    {[1,2,3].map(dot => (
      <Box key={dot} sx={{
        width:5, height:5, borderRadius:'50%', bgcolor:C.accent,
        animation:'pulse 1.4s ease-in-out infinite',
        animationDelay:`${dot * 0.16}s`,
        '@keyframes pulse': {
          '0%, 80%, 100%': { transform:'scale(0.8)', opacity:0.5 },
          '40%':            { transform:'scale(1)',   opacity:1   },
        },
      }}/>
    ))}
    <Typography sx={{ fontSize:'10px', color:C.accent, fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>
      Pending
    </Typography>
  </Box>
)}
                            </Box>
                          </Box>
                        </Tooltip>
                      </TableCell>
                    )}

                    {/* Last Comment */}
                    {colConfig.find(c=>c.key==='lastComment')?.visible && (
                      <TableCell sx={{ px: '12px', textAlign: 'center' }}>
                        <CommentCell lead={lead} />
                      </TableCell>
                    )}

                    {/* ── Stage — with date-based color logic ── */}
                    {colConfig.find(c=>c.key==='stage')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        {lead.stage?.name && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: lead.stagedateupdated ? '4px' : 0 }}>
                            {lead.stage.name === 'Done Deal'       ? <span style={{ fontSize: '18px' }}>🎉</span>
                            : lead.stage.name === 'Pending'        ? <SevereColdIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                            : lead.stage.name === 'Fresh'          ? <CheckIcon sx={{ fontSize: '18px', color: '#4caf50', flexShrink: 0 }} />
                            : lead.stage.name === 'Not Interested' ? <Box sx={{ width: 20, height: 20, bgcolor: '#555', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '14px', fontWeight: 700, flexShrink: 0 }}>—</Box>
                            : lead.stage.name === 'EOI'            ? <EditNoteIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                            : lead.stage.name === 'Reservation'    ? <AssignmentTurnedInIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                            : lead.stage.name === 'Transfer'       ? <TransferWithinAStationIcon sx={{ color: C.danger, fontSize: '18px', flexShrink: 0 }} />
                            : lead.stage.name === 'No Answer'      ? <Box sx={{
                                width:18, height:18, borderRadius:'50%', flexShrink:0,
                                bgcolor: lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment()) ? '#CC5500' : C.accent,
                              }}/>
                            : <Box sx={{
                                width: 18, height: 18, borderRadius: '50%', flexShrink: 0,
                                bgcolor: lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment())
                                  ? '#CC5500'   // الوقت عدى → احمر
                                  : C.accent,   // الوقت لسه جاي → كحلي
                              }}
                            />}

                            {/* Stage name badge */}
                            <Box sx={{ display: 'inline-flex', alignItems: 'center', px: '8px', py: '3px', borderRadius: '20px',
                              bgcolor: lead.stage.name === 'Done Deal'       ? C.successSoft
                                : lead.stage.name === 'Transfer'             ? C.dangerSoft
                                : lead.stage.name === 'Not Interested'       ? 'rgba(85,85,85,0.08)'
                                : lead.stage.name === 'Fresh'                ? 'rgba(76,175,80,0.08)'
                                : lead.stage.name === 'No Answer'            ? (lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment()) ? 'rgba(204,85,0,0.1)' : C.accentSoft)
                                : (lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment())) ? 'rgba(204,85,0,0.1)'
                                : C.accentSoft,
                              color: lead.stage.name === 'Done Deal'         ? C.success
                                : lead.stage.name === 'Transfer'             ? C.danger
                                : lead.stage.name === 'Not Interested'       ? '#555'
                                : lead.stage.name === 'Fresh'                ? '#4caf50'
                                : lead.stage.name === 'No Answer'            ? (lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment()) ? '#CC5500' : C.accent)
                                : (lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment())) ? '#CC5500'
                                : C.accent,
                            }}>
                              <Typography sx={{ fontSize: '11.5px', fontWeight: 600, fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap' }}>{lead.stage.name}</Typography>
                            </Box>
                          </Box>
                        )}
                        {lead.stagedateupdated && (
                          <Typography sx={{ fontSize: '10.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", mt: '2px', display: 'flex', alignItems: 'center', gap: '3px' }}>
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                            {moment(lead.stagedateupdated).format('DD/MM/YY HH:mm')}
                          </Typography>
                        )}
                      </TableCell>
                    )}

                    {/* Status */}
                    {colConfig.find(c=>c.key==='status')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', px: '10px', py: '3px', borderRadius: '20px',
                          bgcolor: lead.leadisactive === 'true' ? C.successSoft : 'rgba(123,130,154,0.08)',
                          color:  lead.leadisactive === 'true' ? C.success : C.textMuted }}>
                          <Typography sx={{ fontSize: '12px', fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
                            {lead.leadisactive === 'true' ? 'Active' : 'Inactive'}
                          </Typography>
                        </Box>
                      </TableCell>
                    )}

                    {/* Added By */}
                    {colConfig.find(c=>c.key==='addedBy')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Avatar sx={{ width: 30, height: 30, fontSize: '11px', fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, fontFamily: "'DM Sans', sans-serif", flexShrink: 0 }}>
                            {getInitials(lead.addby?.name)}
                          </Avatar>
                          <Box>
                            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3 }}>{lead.addby?.name || '—'}</Typography>
                            <Typography sx={{ fontSize: '10px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.addby?.role || ''}</Typography>
                          </Box>
                        </Box>
                      </TableCell>
                    )}

                    {/* Created At */}
                    {colConfig.find(c=>c.key==='createdAt')?.visible && (
                      <TableCell sx={{ px: '12px' }}>
                        <Typography sx={{ fontSize: '13px', color: C.text, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{lead.createdAt ? moment(lead.createdAt).format('DD/MM/YY') : '—'}</Typography>
                        <Typography sx={{ fontSize: '11px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.createdAt ? moment(lead.createdAt).format('HH:mm') : ''}</Typography>
                      </TableCell>
                    )}

                    {/* Actions */}
                    {colConfig.find(c=>c.key==='actions')?.visible && (
                      <TableCell sx={{ px: '8px', textAlign: 'center' }}>
                        <ActionsMenu user={lead} allusers={loadLeads} />
                      </TableCell>
                    )}
                  </StyledRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          {!loading && resleads?.data?.length > 0 && (
            <Box sx={{ px: 2.5, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', borderTop: `1px solid ${C.border}`, flexWrap: 'wrap', gap: 1.5, bgcolor: '#ece8e8', position: 'fixed', bottom: 0, borderRadius: '0px 25px 25px 0px', zIndex: 10, boxShadow: '0 -2px 8px rgba(16,24,40,0.06)' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap' }}>Rows per page:</Typography>
                <TextField select value={itemsPerPage} onChange={e => { setItemsPerPage(e.target.value); setCurrentPage(1); const sp = new URLSearchParams(location.search); loadLeads(1, e.target.value, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters,sp.get('salesId'),getOutsourceParam()); }} size="small" sx={{ width: 72, '& .MuiOutlinedInput-root': { borderRadius: '8px', fontSize: '13px' } }}>
                  {[25, 50, 100, 250].map(n => <MenuItem key={n} value={n} sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: '13px' }}>{n}</MenuItem>)}
                </TextField>
              </Box>
              <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>
                Showing <Box component="span" sx={{ fontWeight: 700, color: C.text }}>{resleads.data.length}</Box> of <Box component="span" sx={{ fontWeight: 700, color: C.text }}>{pagination?.totalItems || resleads.data.length}</Box>
              </Typography>
              {pagination?.NumberOfPages > 1 && (
                <Pagination count={pagination.NumberOfPages} page={currentPage} size="small" showFirstButton showLastButton
                  // onChange={(_, v) => { setCurrentPage(v); const sp = new URLSearchParams(location.search); loadLeads(v, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                                  onChange={(_, v) => { setCurrentPage(v); const sp = new URLSearchParams(location.search); loadLeads(v, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters ,sp.get('salesId'),getOutsourceParam(),); window.scrollTo({ top: 0, behavior: 'smooth' }); }}

                  sx={{ '& .MuiPaginationItem-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '13px', borderRadius: '6px', color: C.textMuted }, '& .Mui-selected': { bgcolor: `${C.accent} !important`, color: '#fff', fontWeight: 700 }, '& .MuiPaginationItem-root:hover': { bgcolor: C.accentSoft } }}
                />
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* ── Modals ── */}
      {/* {selectedLead && <ShowClientsActionsAdvanced user={selectedLead} leadid={selectedLead._id} onClose={() => setSelectedLead(null)} />} */}
         {selectedLead && (
        <ShowClientsActionsAdvanced
          user={selectedLead}
          leadid={selectedLead._id}
          onClose={() => setSelectedLead(null)}
          onLeadUpdated={() => {
            const sp = new URLSearchParams(location.search);
            loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters);
          }}
        />
      )}
      
      <LeadDuplicationModal open={duplication.open} onClose={() => setDuplication({ open: false, leadId: null, leadName: '' })} leadId={duplication.leadId} leadName={duplication.leadName} />
      <QuickFilterModal open={quickFilter} pageType="crm"  onClose={() => setQuickFilter(false)} onApplyFilters={f => { setAppliedFilters(f); setCurrentPage(1); const sp = new URLSearchParams(location.search); loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), f, sp.get('salesId'),getOutsourceParam()); }} />
      <Admin_Report_Model_For_Requested_Data open={adminReportOpen} onClose={() => setAdminReportOpen(false)} />
      {showAssign && <AssignLeadsModal show={showAssign} onHide={() => setShowAssign(false)} refreshData={refresh} />}


<BulkEditDrawer
  open={bulkEditOpen}
  onClose={() => setBulkEditOpen(false)}
  selectedLeads={selectedLeads}
  onSuccess={() => {
    setSelectedLeads([]);
    setSelectAll(false);
    refresh();
  }}
/>
      {/* Delete Confirm */}
      <Dialog open={showDelete} onClose={() => setShowDelete(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700 }}>Delete {selectedLeads.length} lead(s)?</DialogTitle>
        <DialogContent><Alert severity="warning">This action cannot be undone.</Alert></DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDelete(false)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>

      {/* Transfer to Original Leads */}
      <Dialog open={tolOpen} onClose={() => !tolLoading && setTolOpen(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}>
        <DialogTitle sx={{ background: 'linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)', color: '#fff', fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '17px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SwapHorizIcon />
            </Box>
            Move to Original Leads
          </Box>
          <IconButton onClick={() => setTolOpen(false)} sx={{ color: '#fff' }} disabled={tolLoading}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, mb: 2.5, bgcolor: 'rgba(103,232,249,0.06)', border: '1px solid rgba(103,232,249,0.2)', borderRadius: '12px' }}>
            <Box sx={{ width: 44, height: 44, borderRadius: '10px', bgcolor: 'rgba(103,232,249,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <SwapHorizIcon sx={{ color: '#06b6d4', fontSize: '24px' }} />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 700, fontSize: '14px', color: C.text, fontFamily: "'DM Sans', sans-serif" }}>{selectedLeads.length} lead{selectedLeads.length !== 1 ? 's' : ''} will be moved</Typography>
              <Typography sx={{ fontSize: '12px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", mt: '2px' }}>From <strong>Data Center</strong> → <strong>Original Leads</strong></Typography>
            </Box>
          </Box>
          <Alert severity="warning" sx={{ mb: 2.5, borderRadius: '10px', fontFamily: "'DM Sans', sans-serif" }}>
            This will set <code>transferefromdata: true</code> on the selected leads. This action cannot be undone from here.
          </Alert>
          <Typography sx={{ fontSize: '13px', color: C.text, fontFamily: "'DM Sans', sans-serif", mb: 1, fontWeight: 500 }}>
            Type <strong style={{ color: C.accent }}>{selectedLeads.length}</strong> to confirm
          </Typography>
          <TextField fullWidth type="number" placeholder={`Enter ${selectedLeads.length}`} value={tolCount} onChange={e => { setTolCount(e.target.value); setTolError(''); }} error={!!tolError} helperText={tolError} disabled={tolLoading}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', fontFamily: "'DM Sans', sans-serif" }, '& .MuiFormHelperText-root': { fontFamily: "'DM Sans', sans-serif" } }} />
          {tolLoading && (
            <Box sx={{ display: 'flex', gap: 1.5, mt: 2, alignItems: 'center' }}>
              <CircularProgress size={18} sx={{ color: C.accent }} />
              <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>Moving leads to Original...</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button onClick={() => setTolOpen(false)} disabled={tolLoading} sx={{ fontFamily: "'DM Sans', sans-serif", textTransform: 'none', borderRadius: '10px', color: C.textMuted }}>Cancel</Button>
          <Button variant="contained" onClick={confirmTransferToOriginal} disabled={tolLoading || parseInt(tolCount) !== selectedLeads.length}
            startIcon={tolLoading ? <CircularProgress size={16} color="inherit" /> : <SwapHorizIcon />}
            sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'none', borderRadius: '10px', px: '20px', bgcolor: '#0D47A1', '&:hover': { bgcolor: '#1330A6' }, '&:disabled': { bgcolor: C.border, color: C.textMuted } }}>
            {tolLoading ? 'Moving...' : `Confirm Move (${selectedLeads.length})`}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Settings Drawer */}
      <Drawer anchor="right" open={settingsOpen} onClose={() => setSettingsOpen(false)} PaperProps={{ sx: { width: 380, bgcolor: '#F4F6FB !important', display: 'flex', flexDirection: 'column' } }}>
        <Box sx={{ px: 2.5, py: 2, bgcolor: C.white, borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setSettingsOpen(false)} size="small" sx={{ color: C.text, mr: 0.5 }}><CloseIcon fontSize="small" /></IconButton>
          <Typography sx={{ fontWeight: 700, fontSize: '17px', fontFamily: "'DM Sans', sans-serif", color: C.text, flex: 1 }}>Export & Settings</Typography>
        </Box>
        <Box sx={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
          <Box sx={{ px: 2.5, pt: 2.5, pb: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {[{ label: 'Export to Excel with Last Comment', fn: exportExcel }, { label: 'Export with All Comments', fn: exportAllComments }].map(item => (
              <Box key={item.label} onClick={item.fn} sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 2.5, py: 2, bgcolor: C.accent, borderRadius: '14px', cursor: 'pointer', boxShadow: '0 4px 14px rgba(26,62,207,0.25)', '&:hover': { bgcolor: C.accentDark, transform: 'translateY(-1px)' }, transition: 'all 0.15s' }}>
                <Box sx={{ width: 44, height: 44, borderRadius: '10px', bgcolor: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <SystemUpdateAltIcon sx={{ color: '#fff', fontSize: '22px' }} />
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: '15px', color: '#fff', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3 }}>{item.label}</Typography>
              </Box>
            ))}
          </Box>
          <Divider sx={{ mx: 2.5, my: 1 }} />
          <Box sx={{ px: 2.5, pb: 3 }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 700, color: C.accent, letterSpacing: '0.1em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif", mb: 2 }}>Column Order &amp; Visibility</Typography>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="columns">
                {(provided) => (
                  <Box ref={provided.innerRef} {...provided.droppableProps} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {colConfig.map((col, index) => (
                      <Draggable key={col.key} draggableId={col.key} index={index}>
                        {(provided, snapshot) => (
                          <Box ref={provided.innerRef} {...provided.draggableProps}
                            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5, bgcolor: snapshot.isDragging ? '#E8ECFF' : C.white, borderRadius: '14px', border: `1.5px solid ${snapshot.isDragging ? C.accent : C.border}`, boxShadow: snapshot.isDragging ? '0 8px 24px rgba(26,62,207,0.18)' : '0 1px 3px rgba(16,24,40,0.06)', userSelect: 'none' }}>
                            <IconButton size="small" onClick={() => toggleColVisibility(col.key)}
                              sx={{ width: 34, height: 34, borderRadius: '50%', flexShrink: 0, color: col.visible ? C.accent : C.textMuted, bgcolor: col.visible ? C.accentSoft : 'rgba(123,130,154,0.08)' }}>
                              {col.visible ? <VisibilityIcon sx={{ fontSize: '17px' }} /> : <VisibilityOffIcon sx={{ fontSize: '17px' }} />}
                            </IconButton>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: col.visible ? C.text : C.textMuted, fontFamily: "'DM Sans', sans-serif", textDecoration: col.visible ? 'none' : 'line-through' }}>{col.label}</Typography>
                              <Typography sx={{ fontSize: '10.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.05em', textTransform: 'uppercase' }}>ID: {col.fieldId}</Typography>
                            </Box>
                            <Box sx={{ width: 48, height: 36, bgcolor: '#F0F2F9', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                              <input type="number" value={col.w} onChange={e => updateColWidth(col.key, e.target.value)} onClick={e => e.stopPropagation()} style={{ width: '100%', height: '100%', border: 'none', outline: 'none', background: 'transparent', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif" }} />
                            </Box>
                            <Box {...provided.dragHandleProps} sx={{ display: 'flex', flexDirection: 'column', gap: '3px', cursor: 'grab', px: '2px', flexShrink: 0 }}>
                              {[0,1,2].map(r => <Box key={r} sx={{ display: 'flex', gap: '3px' }}>{[0,1].map(c => <Box key={c} sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: snapshot.isDragging ? C.accent : C.textMuted, opacity: 0.6 }} />)}</Box>)}
                            </Box>
                          </Box>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          </Box>
        </Box>
        <Box sx={{ px: 2.5, py: 2, borderTop: `1px solid ${C.border}`, bgcolor: C.white, display: 'flex', gap: 1 }}>
          <Button fullWidth variant="outlined" onClick={() => setColConfig(DEFAULT_COLS)} sx={{ borderColor: C.border, color: C.textMuted, fontFamily: "'DM Sans', sans-serif", textTransform: 'none', borderRadius: '10px', '&:hover': { borderColor: C.accent, color: C.accent } }}>Reset to Default</Button>
          <Button fullWidth variant="contained" onClick={() => setSettingsOpen(false)} sx={{ bgcolor: C.accent, '&:hover': { bgcolor: C.accentDark }, textTransform: 'none', fontFamily: "'DM Sans', sans-serif", borderRadius: '10px', fontWeight: 600 }}>Done</Button>
        </Box>
      </Drawer>
    </Box>
  );
};
